(function () {
  'use strict';

  // Skrypt może zostać wstrzyknięty ponownie (przeładowanie sekcji w edytorze) — jedna instancja na stronę
  if (window.__bundlePromoInit) return;
  window.__bundlePromoInit = true;

  var DISCOUNT_KEY = 'icedstuff_discounts';
  // uid zestawu → wymintowany kod (mini-cart usuwa przy „Usuń zestaw” tylko kod tego zestawu)
  var BUNDLE_CODES_KEY = 'icedstuff_bundle_codes';
  var BOUND = 'data-bundle-upsell-bound';
  var MINT_ENDPOINT = (window.ICS_MINT_ENDPOINT || 'https://iced-stuff-bundle-codes.krystian-smidowicz.workers.dev').replace(/\/+$/, '');

  // „Wstecz” na telefonie zamyka arkusz (pushState przy otwarciu)
  var HISTORY_CLOSE = true;
  var ADD_TIMEOUT = 12000;
  var COUNT_MS = 600;
  var MINUS = '–'; // półpauza (U+2013): znaku minus U+2212 nie ma w krojach sklepu — rysowałby się czcionką systemową
  var NET_ERROR = 'Nie udało się dodać do koszyka. Sprawdź internet i spróbuj ponownie.';
  // 2026-10-16: kody zestawów nie łączą się ze sobą, a kwota kodu liczy się raz na zamówienie,
  // więc drugi zestaw w koszyku (także taki sam) nie dostałby rabatu w kasie
  var ONE_BUNDLE_MSG = 'W koszyku masz już zestaw. Rabat obejmuje jeden zestaw na zamówienie, więc najpierw dokończ to zamówienie albo usuń zestaw z koszyka.';

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getMainProductForm() {
    var mainForm = document.querySelector('.product__info form[is="product-form"]');
    if (mainForm && !mainForm.closest('template')) return mainForm;

    return $$('form[is="product-form"]').find(function (f) {
      return !f.closest('template');
    }) || null;
  }

  // Kwota wg formatu sklepu. Domyślnie bez końcowych zer (jak money_without_trailing_zeros: karty, hero „189 zł”);
  // keepZeros = z końcówką „,00” — stopka jak widget kreatora zestawów („Oszczędzasz 189,00 zł”, „299,00 zł”)
  function formatMoney(cents, keepZeros) {
    var settings = window.themeVariables && window.themeVariables.settings;
    var format = (settings && settings.moneyFormat) || '{{amount_with_comma_separator}} zł';
    var value = (Number(cents) || 0) / 100;

    function num(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_no_decimals': return num(0, ',', '.');
        default: return num(2, ',', '.');
      }
    });
    out = out.replace(/<[^>]*>/g, '');
    return keepZeros ? out : out.replace(/[.,]00(?=\D|$)/, '');
  }

  var fm = formatMoney;
  var fmFull = function (cents) { return formatMoney(cents, true); };

  function readJSON(key, fallback) {
    try {
      var data = JSON.parse(localStorage.getItem(key));
      return data == null ? fallback : data;
    } catch (e) {
      return fallback;
    }
  }

  function writeJSON(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function saveDiscount(code) {
    if (!code) return;
    var discounts = readJSON(DISCOUNT_KEY, []);
    if (!Array.isArray(discounts)) discounts = [];
    var upper = String(code).toUpperCase();
    if (!discounts.some(function (d) { return String(d.code).toUpperCase() === upper; })) {
      discounts.push({ code: code, savings: 0, currency: 'PLN' });
      writeJSON(DISCOUNT_KEY, discounts);
    }
  }

  function rememberBundleCode(uid, code) {
    if (!uid || !code) return;
    var map = readJSON(BUNDLE_CODES_KEY, {});
    if (typeof map !== 'object' || Array.isArray(map)) map = {};
    map[uid] = code;
    writeJSON(BUNDLE_CODES_KEY, map);
  }

  // Unikalny identyfikator dodanego zestawu → osobne pozycje i osobna grupa w koszyku
  function newBundleUid() {
    return Date.now().toString(36).slice(-4) + Math.random().toString(36).slice(2, 6);
  }

  async function mintBundleCode(bundleKey, variantIds) {
    if (!bundleKey || !variantIds || !variantIds.length) return null;

    var res = await fetch(MINT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        bundle: bundleKey,
        variantIds: variantIds.map(Number)
      })
    });

    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error(data.error || ('mint: ' + res.status));
    return data.code || null;
  }

  async function fetchCart() {
    var res = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    return res.json();
  }

  // Ten sam payload co wcześniej; signal = AbortController (limit 12 s), błąd niesie status i opis
  async function addBundlePair(mainVariantId, complementVariantId, bundleCode, bundleUid, signal, bundlePrice) {
    var props = {};
    if (bundleCode) props._bundle = bundleCode;
    if (bundleUid) props._bundle_uid = bundleUid;
    // v6.12: cena zestawu (grosze) — koszyk od razu pokazuje „299 zł · 488 zł · Oszczędzasz 189 zł”
    if (bundlePrice > 0) props._bundle_price = String(bundlePrice);

    var payload = {
      items: [
        { id: Number(mainVariantId), quantity: 1, properties: props },
        { id: Number(complementVariantId), quantity: 1, properties: props }
      ]
    };

    var res = await fetch((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartAddUrl) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      signal: signal
    });

    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) {
      var description = (data && (data.description || data.message)) || '';
      var err = new Error(description || 'Nie udało się dodać do koszyka');
      err.status = res.status;
      err.description = description;
      throw err;
    }
    return data;
  }

  function applyDiscountNow(code) {
    if (!code) return Promise.resolve();
    // Nie zapisuj kodu wcześniej — calculateDiscount wtedy widzi „już użyty”
    // i wychodzi bez aktualizacji cen w drawerze.
    if (typeof window.applyCartDiscount === 'function') {
      return Promise.resolve(window.applyCartDiscount(code, true, true)).catch(function (err) {
        console.warn('[bundle-upsell] applyCartDiscount failed', err);
        saveDiscount(code);
      });
    }
    saveDiscount(code);
    document.dispatchEvent(new CustomEvent('bundle:apply-discount', {
      bubbles: true,
      detail: { code: code }
    }));
    return Promise.resolve();
  }

  // Po applyDiscountNow: przeliczenie rabatów w drawerze (150 ms później, jak dotąd)
  function recalcLater() {
    if (typeof window.recalculateCartDiscounts !== 'function') return Promise.resolve(null);
    return new Promise(function (resolve) {
      setTimeout(function () {
        try {
          Promise.resolve(window.recalculateCartDiscounts()).then(resolve, resolve);
        } catch (e) {
          resolve(null);
        }
      }, 150);
    });
  }

  var openingLock = false;

  function setDrawerLock(locked) {
    window.__bundlePromoDrawerLock = !!locked;
    window.__cartRecsRefreshScheduled = !!locked;
  }

  function updateCartCount(fullCart) {
    try {
      var count = fullCart && typeof fullCart.item_count === 'number' ? fullCart.item_count : null;
      if (count !== null) {
        document.querySelectorAll('cart-count').forEach(function (el) {
          el.textContent = String(count);
        });
      }
    } catch (e) {}
  }

  // Jedno otwarcie: tylko cart:refresh z openMiniCart (bez osobnego drawer.open)
  function refreshAndOpenCart(fullCart) {
    if (openingLock) return;
    openingLock = true;
    setDrawerLock(true);
    updateCartCount(fullCart);

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        openMiniCart: true,
        replacementDelay: 0,
        cart: fullCart || null
      }
    }));

    setTimeout(function () {
      openingLock = false;
      setDrawerLock(false);
    }, 1500);
  }

  /* ============ Karuzela (jak v3) ============ */

  function setupCarousel(root) {
    var track = root.querySelector('[data-bundle-track]');
    var nav = root.querySelector('[data-bundle-nav]');
    var prev = root.querySelector('[data-bundle-prev]');
    var next = root.querySelector('[data-bundle-next]');
    if (!track || !nav || !prev || !next) return;

    function updateNav() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var needsNav = maxScroll > 4;
      nav.hidden = !needsNav;
      if (!needsNav) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollByCard(dir) {
      var card = track.querySelector('.bundle-upsell__card');
      var amount = card ? card.offsetWidth + 8 : 140;
      // Ograniczony ruch: bez płynnego przewijania (CSS też wyłącza scroll-behavior)
      track.scrollBy({ left: dir * amount, behavior: RM.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByCard(-1); });
    next.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  // v5: jedna widoczna para w układach „polecana” / „razem”; miniatury z aria-pressed
  /* ============ v6 „Twoja para”: kafle + pasek pary ============ */

  // Licznik w pasku pary: w trakcie tylko pełne złote (bez „40,27 zł”), na końcu dokładna kwota; token unieważnia stare klatki
  // v6.6: zmiana kwoty bez liczenia przez wartości pośrednie (test: „109 zł” obok „−189 zł” wyglądało jak trzecia
  // kwota) — od razu właściwa liczba i krótkie „tyknięcie” (przenikanie + 4 px w górę); bez ruchu przy reduced-motion
  function paraCount(el, from, to) {
    if (!el) return;
    el.__tok = (el.__tok || 0) + 1;
    el.textContent = fm(to);
    el.__v = to;
    if (RM.matches || from === to) return;
    el.classList.remove('is-tick');
    void el.offsetWidth;
    el.classList.add('is-tick');
  }

  // Lot zdjęcia z kafla do kółka pary (WAAPI); bez ruchu przy reduced-motion
  function paraFly(fromImg, target, src, done) {
    if (RM.matches || !HAS_WAAPI || !fromImg || !target) { done(); return; }
    var a = fromImg.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    if (!a.width || !b.width) { done(); return; }
    var clone = document.createElement('img');
    clone.src = src;
    clone.alt = '';
    clone.className = 'bundle-upsell__pfly';
    clone.style.left = a.left + 'px';
    clone.style.top = a.top + 'px';
    clone.style.width = a.width + 'px';
    clone.style.height = a.height + 'px';
    document.body.appendChild(clone);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var sc = b.width / a.width;
    var finished = false;
    function end() {
      if (finished) return;
      finished = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      done();
    }
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1)', borderRadius: '10px' },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 22) + 'px) scale(' + (1 + sc) / 2 + ')', borderRadius: '30%', offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ')', borderRadius: '50%' }
    ], { duration: 520, easing: EASE_OUT });
    anim.onfinish = end;
    setTimeout(end, 750);
  }

  function paraSelected(root) {
    return q(root, '[data-para-tile].is-on') || q(root, '[data-para-tile]');
  }

  // Pasek „Twoja para” z liczb wybranego kafla (te same wzory co karty: cardNumbers)
  function paintParaBar(root, tile, animate) {
    var bar = q(root, '[data-para-bar]');
    if (!bar || !tile) return;
    var n = cardNumbers(root, tile);
    var od = n.cmin !== n.cmax ? 'od ' : '';
    setText(q(bar, '[data-para-name]'), tile.getAttribute('data-para-name') || '');
    setText(q(bar, '[data-para-sum]'), od + fm(n.M + n.cmin));
    // v6.6: zdanie o okazji („Bransoletka gratis do łańcucha” / „Razem 79 zł taniej niż osobno”) — te same warunki co Liquid
    var deal = q(bar, '[data-para-deal]');
    if (deal) {
      var nouns = (root.getAttribute('data-nouns') || '').split('|');
      var text = 'Razem ' + fm(n.save) + ' taniej niż osobno';
      if (nouns.length === 4) {
        if (n.cmin === n.B && n.cmin === n.cmax) text = nouns[0] + ' gratis do ' + nouns[3];
        else if (n.M === n.B) text = nouns[2] + ' gratis do ' + nouns[1];
      }
      setText(deal, text);
    }
    var save = q(bar, '[data-para-save]');
    if (save) {
      var prev = typeof save.__v === 'number' ? save.__v : n.save;
      if (animate) paraCount(save, prev, n.save);
      else { save.__tok = (save.__tok || 0) + 1; save.textContent = fm(n.save); save.__v = n.save; }
    }
    // v6.1: kwota w pasku ze zdjęciem = oszczędność wybranej pary (bez „do”), licznik jak w pigułce
    var hero = q(root, '[data-para-hero]');
    if (hero) {
      var hprev = typeof hero.__v === 'number' ? hero.__v : n.save;
      if (animate) paraCount(hero, hprev, n.save);
      else { hero.__tok = (hero.__tok || 0) + 1; hero.textContent = fm(n.save); hero.__v = n.save; }
    }
    var img = q(bar, '[data-para-img]');
    var src = tile.getAttribute('data-para-img') || '';
    if (!img || !src || img.getAttribute('src') === src) return;
    if (!animate) { img.setAttribute('src', src); return; }
    img.classList.add('is-fade');
    paraFly(q(tile, '.bundle-upsell__media img'), q(bar, '[data-para-target]'), src, function () {
      img.setAttribute('src', src);
      requestAnimationFrame(function () { img.classList.remove('is-fade'); });
      setTimeout(function () { img.classList.remove('is-fade'); }, 120);
      bar.classList.remove('is-flash');
      void bar.offsetWidth;
      if (!RM.matches) bar.classList.add('is-flash');
    });
  }

  // Nazwy kafli dla czytników („…, oszczędzasz 189 zł”) po zmianie wariantu produktu ze strony — kwota jak na plakietce
  function labelParaTiles(root) {
    $$('[data-para-tile]', root).forEach(function (t) {
      var base = (t.getAttribute('aria-label') || '').split(', oszczędzasz')[0];
      var n = cardNumbers(root, t);
      t.setAttribute('aria-label', n.save > 0 ? base + ', oszczędzasz ' + fm(n.save) : base);
    });
  }

  function selectParaTile(root, tile) {
    if (!tile || tile.classList.contains('is-on')) return;
    $$('[data-para-tile]', root).forEach(function (t) {
      var on = t === tile;
      t.classList.toggle('is-on', on);
      // v6.1: rząd kafli = grupa radiowa (jeden przystanek Tab, strzałki między łańcuchami)
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    paintParaBar(root, tile, true);
    // Kafel przy krawędzi — płynnie do środka rzędu (zamiast szarpnięcia od przewijania do fokusu)
    var row = tile.parentNode;
    if (!row || !row.getBoundingClientRect) return;
    var tr = tile.getBoundingClientRect();
    var rr = row.getBoundingClientRect();
    if (tr.left < rr.left + 12 || tr.right > rr.right - 12) {
      row.scrollBy({ left: tr.left - rr.left - (rr.width - tr.width) / 2, behavior: RM.matches ? 'auto' : 'smooth' });
    }
  }

  function setupPara(root) {
    if (root.getAttribute('data-layout') !== 'para') return;
    var tiles = $$('[data-para-tile]', root);
    if (!tiles.length) return;
    if (!q(root, '[data-para-tile].is-on')) tiles[0].classList.add('is-on');
    var current = paraSelected(root);
    tiles.forEach(function (t) {
      t.setAttribute('aria-checked', t === current ? 'true' : 'false');
      t.setAttribute('tabindex', t === current ? '0' : '-1');
    });
    paintParaBar(root, current, false);
    // Klawiatura jak w grupie radiowej: strzałki / Home / End przenoszą fokus i wybór (test: 6 osobnych Tabów)
    tiles[0].parentNode.addEventListener('keydown', function (e) {
      var t = e.target.closest ? e.target.closest('[data-para-tile]') : null;
      if (!t) return;
      var i = tiles.indexOf(t);
      var next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tiles.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tiles.length) % tiles.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tiles.length - 1;
      if (next < 0) return;
      e.preventDefault();
      tiles[next].focus({ preventScroll: true });
      selectParaTile(root, tiles[next]);
    });
    // Fokus myszą nie przewija rzędu kafli (to dawało „skok”); klawiatura działa normalnie
    root.addEventListener('mousedown', function (e) {
      if (e.target.closest('[data-para-tile]')) e.preventDefault();
    });
    // Zdjęcia łańcuchów z góry — płynna podmiana w kółku pary
    tiles.forEach(function (t) {
      var src = t.getAttribute('data-para-img');
      if (src) { var im = new Image(); im.src = src; }
    });
    // v6.1: strzałki nad rzędem kafli — tylko mysz (dotyk przesuwa palcem, klawiatura idzie po kaflach)
    var row = tiles[0].parentNode;
    var navs = $$('[data-para-nav]', root);
    if (navs.length && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var syncNav = function () {
        var max = row.scrollWidth - row.clientWidth;
        navs.forEach(function (b) {
          var dir = parseInt(b.getAttribute('data-para-nav'), 10);
          b.hidden = max <= 4;
          b.disabled = dir < 0 ? row.scrollLeft <= 4 : row.scrollLeft >= max - 4;
        });
      };
      navs.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var dir = parseInt(b.getAttribute('data-para-nav'), 10);
          var step = tiles[0].getBoundingClientRect().width + 10;
          row.scrollBy({ left: dir * step * 2, behavior: RM.matches ? 'auto' : 'smooth' });
        });
      });
      row.addEventListener('scroll', syncNav, { passive: true });
      window.addEventListener('resize', syncNav);
      syncNav();
    }
    // v6.8: gdy blok zestawu jest na ekranie (≥ 40%), chowamy przyklejony pasek „DODAJ DO KOSZYKA” z ceną samego
    // produktu — dwa przyciski z różnymi cenami naraz myliły (test); klasa na <html>, CSS jak przy otwartym oknie
    var paraBox = q(root, '.bundle-upsell__para');
    if (paraBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        document.documentElement.classList.toggle('bundle-para-in-view', e.isIntersecting && e.intersectionRatio >= 0.4);
      }, { threshold: [0, 0.4, 0.6] }).observe(paraBox);
    }
    // v6.10: jednorazowe „pokazanie”, że rząd się przewija (telefon — strzałek nie ma): przy pierwszym wejściu bloku
    // na ekran kafle zjeżdżają 36 px w lewo i wracają. Raz na sesję, tylko dotyk, bez ruchu przy reduced-motion,
    // pomijane, gdy klient już dotknął albo przewinął rząd (test: 58-latek nie wiedział, że można przesunąć)
    var touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;
    if (touchOnly && HAS_WAAPI && !RM.matches && 'IntersectionObserver' in window) {
      var nudged = false;
      try { nudged = window.sessionStorage.getItem('bu_para_nudge') === '1'; } catch (e) {}
      if (!nudged) {
        var touched = false;
        row.addEventListener('pointerdown', function () { touched = true; }, { passive: true });
        var nio = new IntersectionObserver(function (entries) {
          var seen = entries.some(function (e) { return e.isIntersecting && e.intersectionRatio >= 0.6; });
          if (!seen) return;
          nio.disconnect();
          setTimeout(function () {
            if (touched || row.scrollLeft > 4 || row.scrollWidth <= row.clientWidth + 8) return;
            try { window.sessionStorage.setItem('bu_para_nudge', '1'); } catch (e) {}
            tiles.forEach(function (t) {
              t.animate([
                { transform: 'translateX(0)' },
                { transform: 'translateX(-36px)', offset: 0.45 },
                { transform: 'translateX(0)' }
              ], { duration: 900, easing: 'cubic-bezier(0.45, 0, 0.2, 1)' });
            });
          }, 1000);
        }, { threshold: [0.6] });
        nio.observe(row);
      }
    }
    // Wejście kafli kaskadą, gdy rząd pojawi się na ekranie (CSS .is-armed → .is-in; bez JS kafle widać od razu)
    if (!RM.matches && 'IntersectionObserver' in window) {
      tiles.forEach(function (t, i) { t.style.setProperty('--d', Math.min(i, 6) * 60 + 'ms'); });
      root.classList.add('is-armed');
      var reveal = function () { root.classList.add('is-in'); };
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { reveal(); io.disconnect(); return; }
        }
      }, { threshold: 0.2 });
      io.observe(tiles[0].parentNode);
      root.addEventListener('focusin', reveal);
      root.addEventListener('pointerdown', reveal);
    }
  }

  function selectPair(root, handle) {
    if (!handle) return;
    $$('[data-bundle-card][data-pair]', root).forEach(function (card) {
      card.hidden = card.getAttribute('data-pair') !== handle;
    });
    $$('[data-pair-pick]', root).forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-pair-pick') === handle ? 'true' : 'false');
    });
  }

  /* ============ Blok na PDP: dopłata, cena przekreślona, oszczędność (v2.2) ============ */

  // Te same wzory co Liquid (product-bundle-badge): M = bieżący wariant, Cmin/Cmax = najtańszy/najdroższy
  // DOSTĘPNY wariant karty, save = M + Cmin − B, add = B − M, okazja = B > 0 i save > 0
  function cardNumbers(root, card) {
    var M = toInt(root.getAttribute('data-main-price'));
    var B = toInt(root.getAttribute('data-bundle-cents'));
    var cmin = toInt(card.getAttribute('data-comp-min') || card.getAttribute('data-comp-price'));
    var cmaxAttr = card.getAttribute('data-comp-max');
    var cmax = cmaxAttr ? toInt(cmaxAttr) : cmin;
    var save = calcSave(M, cmin, B);
    return { M: M, B: B, cmin: cmin, cmax: cmax, save: save, add: B - M, deal: B > 0 && save > 0 };
  }

  // Liczby na PDP bez count-upu — najwyżej krótka podmiana (przenikanie); bez sesji popupu, więc bez worka animacji
  var PDP_SWAP = { anims: null };

  function pdpText(el, text, animate) {
    if (!el) return;
    if (animate) swapText(PDP_SWAP, el, text, 0);
    else putText(el, text);
  }

  // Karty + podtytuł nagłówka; animate = podmiana tekstu (zmiana wariantu na PDP)
  function syncBlock(root, animate) {
    var saves = [];
    $$('[data-bundle-card]', root).forEach(function (card) {
      var n = cardNumbers(root, card);
      card.setAttribute('data-deal', n.deal ? 'true' : 'false');

      // v4.4: przy okazji cena pary „299 zł” + przekreślona suma cen regularnych (M + Cmin, „od ” gdy rozmiary różnią się ceną)
      // pod etykietą „Razem z bransoletką”; bez okazji zwykła cena dobieranego. Bez wyliczonych dopłat („+110 zł” było nieintuicyjne)
      var od = n.cmin !== n.cmax ? 'od ' : '';
      pdpText(q(card, '[data-bundle-price]'), n.deal ? fm(n.B) : od + fm(n.cmin), animate);
      var old = q(card, '[data-bundle-old]');
      if (old) {
        if (n.deal) pdpText(q(old, '[data-bundle-old-amount]') || old, od + fm(n.M + n.cmin), animate && !old.hidden);
        old.hidden = !n.deal;
      }
      toggleHidden(q(card, '[data-bundle-price-k]'), !n.deal);

      // v5 pary: procent, cena produktu ze strony, „Gratis” przy dopłacie 0
      var pct = q(card, '[data-pair-pct]');
      if (pct && n.deal) pdpText(pct, MINUS + Math.round(n.save * 100 / (n.M + n.cmin)) + '%', animate);
      var mainP = q(card, '[data-pair-main-price]');
      if (mainP) pdpText(mainP, fm(n.M), animate);
      var compP = q(card, '[data-pair-comp-price]');
      if (compP) {
        var gratisNow = n.deal && n.add === 0 && root.getAttribute('data-gratis-enabled') !== 'false';
        if (gratisNow) compP.innerHTML = '<s>' + fm(n.cmin) + '</s> <b class="bundle-upsell__gratis">Gratis</b>';
        else pdpText(compP, od + fm(n.cmin), animate);
        card.setAttribute('data-gratis', gratisNow ? 'true' : 'false');
      }

      // Złota plakietka „Oszczędzasz …” — dokładnie dla tej karty, ukryta bez oszczędności
      var badge = q(card, '[data-bundle-save]');
      if (badge) {
        if (n.deal) pdpText(q(badge, '[data-bundle-save-amount]'), fm(n.save), animate && !badge.hidden);
        badge.hidden = !n.deal;
      }
      if (n.deal) saves.push(n.save);
    });

    // Podtytuł: „zyskaj {kwota}” — dokładnie, gdy każda karta-okazja daje tyle samo, inaczej „do {max}”
    var sub = q(root, '[data-bundle-sub]');
    if (!sub) return;
    var dealPart = q(sub, '[data-sub-deal]');
    var plainPart = q(sub, '[data-sub-plain]');
    var has = saves.length > 0;
    if (has) {
      var max = Math.max.apply(null, saves);
      var min = Math.min.apply(null, saves);
      pdpText(q(sub, '[data-bundle-gain]'), (min === max ? '' : 'do ') + fm(max), animate && !!dealPart && !dealPart.hidden);
    }
    toggleHidden(dealPart, !has);
    toggleHidden(plainPart, has);
    sub.setAttribute('data-deal', has ? 'true' : 'false');
    if (root.getAttribute('data-layout') === 'para') {
      labelParaTiles(root);
      paintParaBar(root, paraSelected(root), false);
    }
  }

  /* ============ Ruch: preferencje i drobne helpery ============ */

  // Sprawdzane w chwili wywołania (przełączenie w systemie działa na żywo)
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var HAS_WAAPI = typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';

  // v2.3 (brandbook): ruch = powściągliwość — tylko ease-out / wejście arkusza; bez sprężyn, drgań i obrotów
  var EASE_OUT = 'cubic-bezier(.22,1,.36,1)';
  var EASE_IN = 'cubic-bezier(.4,0,1,1)';

  function toInt(v) {
    return parseInt(v, 10) || 0;
  }

  // Checkboxy bloku jako "true"/"false"; brak atrybutu = domyślna wartość
  function boolAttr(el, name, dflt) {
    var v = el && el.getAttribute(name);
    if (v == null || v === '') return dflt;
    return v !== 'false';
  }

  // Ustawienie bloku: najpierw na popupie, potem na roocie bloku
  function popFlag(popup, root, name, dflt) {
    return boolAttr(popup && popup.hasAttribute(name) ? popup : root, name, dflt);
  }

  function q(scope, sel) {
    return scope ? scope.querySelector(sel) : null;
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function toggleHidden(el, hide) {
    if (el) el.hidden = !!hide;
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function isRendered(el) {
    return !!(el && el.getClientRects().length);
  }

  function intersectsViewport(r) {
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < vh && r.left < vw;
  }

  // Słabsze urządzenia: bez FLIP
  function isLowEnd() {
    var mem = navigator.deviceMemory;
    var cores = navigator.hardwareConcurrency;
    return (typeof mem === 'number' && mem <= 2) || (typeof cores === 'number' && cores < 4);
  }

  // Haptyka tylko przy 2/2 i po dodaniu; iOS bez vibrate = no-op
  function haptic(pattern) {
    if (!('vibrate' in navigator) || RM.matches) return;
    try { navigator.vibrate(pattern); } catch (e) {}
  }

  // WAAPI z will-change na czas animacji; bag = lista do anulowania przy zamknięciu
  function anim(el, frames, opts, bag) {
    if (!el || !HAS_WAAPI) return null;
    var a;
    try { a = el.animate(frames, opts); } catch (e) { return null; }
    var keep = opts.fill === 'forwards' || opts.fill === 'both';
    var ended = false;
    el.__wc = (el.__wc || 0) + 1;
    el.style.willChange = 'transform, opacity';
    function end() {
      if (ended) return;
      ended = true;
      if (el.__wc && --el.__wc === 0) el.style.willChange = '';
      if (bag && !keep) {
        var i = bag.indexOf(a);
        if (i !== -1) bag.splice(i, 1);
      }
    }
    a.addEventListener('finish', end);
    a.addEventListener('cancel', end);
    if (bag) bag.push(a);
    return a;
  }

  // Timer sesji popupu — kasowany razem z sesją
  function later(s, fn, ms) {
    var id = setTimeout(function () {
      var i = s.timers.indexOf(id);
      if (i !== -1) s.timers.splice(i, 1);
      fn();
    }, ms);
    s.timers.push(id);
    return id;
  }

  // Tekst bez animacji (przerywa trwającą podmianę)
  function putText(el, text) {
    if (!el) return;
    el.__want = text;
    if (el.__swap) {
      var a = el.__swap;
      el.__swap = null;
      try { a.cancel(); } catch (e) {}
    }
    setText(el, text);
  }

  // Podmiana tekstu: stary wychodzi w górę (120 ms), nowy wchodzi od dołu (180 ms) — tylko opacity/transform
  function swapText(s, el, text, delay) {
    if (!el) return;
    if (el.__want === text || (el.__want == null && el.textContent === text)) return;
    if (RM.matches || !HAS_WAAPI || !isRendered(el)) {
      putText(el, text);
      return;
    }
    el.__want = text;
    if (el.__swap) {
      var prev = el.__swap;
      el.__swap = null;
      try { prev.cancel(); } catch (e) {}
    }
    var out = anim(el, [
      { opacity: 1, transform: 'translateY(0)' },
      { opacity: 0, transform: 'translateY(-4px)' }
    ], { duration: 120, delay: delay || 0, easing: EASE_IN, fill: 'forwards' }, s.anims);
    if (!out) {
      setText(el, text);
      return;
    }
    el.__swap = out;
    // Zapas: gdy przeglądarka wstrzyma animacje (karta w tle, oszczędzanie energii), 'finish' może nie przyjść —
    // tekst docelowy wchodzi i tak po czasie animacji
    var guard = setTimeout(function () {
      if (el.__swap !== out) return;
      el.__swap = null;
      setText(el, el.__want);
      try { out.cancel(); } catch (e) {}
    }, (delay || 0) + 120 + 250);
    out.addEventListener('finish', function () {
      clearTimeout(guard);
      if (el.__swap !== out) return;
      el.__swap = null;
      setText(el, el.__want);
      anim(el, [
        { opacity: 0, transform: 'translateY(4px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 180, easing: EASE_OUT }, s.anims);
      out.cancel();
    });
    out.addEventListener('cancel', function () {
      clearTimeout(guard);
      // Przerwane z zewnątrz (zamknięcie popupu) — od razu tekst docelowy
      if (el.__swap !== out) return;
      el.__swap = null;
      setText(el, el.__want);
    });
  }

  /* ============ Liczby: jedna formuła wszędzie (jak worker) ============ */

  // Oszczędność = cena produktu + cena drugiego − cena zestawu
  function calcSave(m, c, b) {
    return m + c - b;
  }

  // Procenty zawsze w dół (nigdy nie zawyżamy)
  function floorPct(save, base) {
    return base > 0 && save > 0 ? Math.floor(save * 100 / base) : 0;
  }

  /* ============ Rzeczowniki: podtytuł „BRANSOLETKA + ŁAŃCUCH ZA 299 ZŁ” i CTA przy 1/2 ============ */

  // Dopełniacz rzeczownika („Wybierz rozmiar łańcucha”). Prosta mapa; poza nią CTA mówi „2. produktu”.
  var NOUN_GEN = {
    'łańcuch': 'łańcucha',
    'łańcuszek': 'łańcuszka',
    'naszyjnik': 'naszyjnika',
    'bransoletka': 'bransoletki',
    'zawieszka': 'zawieszki',
    'kolczyki': 'kolczyków',
    'kolczyk': 'kolczyka',
    'koszulka': 'koszulki',
    'sygnet': 'sygnetu',
    'pierścionek': 'pierścionka',
    'zegarek': 'zegarka',
    'krzyż': 'krzyża'
  };
  // Etykieta CTA dłuższa niż tyle znaków → ciaśniejsze rozstrzelenie (CSS .is-long), bez wielokropka w pigułce
  var CTA_LONG = 26;
  // Nazwy opcji, których biernik = mianownik („Wybierz długość …”); inne → „rozmiar”
  var OPTION_ACC = ['rozmiar', 'długość', 'wariant', 'kolor', 'grubość', 'szerokość'];

  // Rzeczownik produktu = pierwsze słowo tytułu (Liquid daje je w data-noun), małymi literami, bez interpunkcji
  function nounOf(item) {
    if (!item) return '';
    var raw = item.getAttribute('data-noun') || (item.getAttribute('data-title') || '').trim().split(/\s+/)[0] || '';
    return raw.replace(/^[^0-9A-Za-z\u00C0-\u024F]+|[^0-9A-Za-z\u00C0-\u024F]+$/g, '').toLowerCase();
  }

  function capFirst(t) {
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }

  // „Bransoletka + łańcuch” (wielkie litery robi CSS; w DOM zdanie dla czytników)
  function pairNouns(st) {
    var a = nounOf(st.main.item);
    var b = nounOf(st.comp.item);
    if (!a || !b) return capFirst(a || b);
    return capFirst(a) + ' + ' + b;
  }

  // CTA przy 1/2 — konkretnie i krótko, czego brakuje: „Wybierz rozmiar łańcucha”. Ten sam rzeczownik po obu
  // stronach albo rzeczownik spoza mapy → numer jak w kółku nad kolumną: „Wybierz długość 2. łańcucha”,
  // „Wybierz rozmiar 1. produktu” (≤ 27 znaków — mieści się w pigułce bez ucinania)
  function missingLabel(st) {
    var missMain = !st.main.resolved;
    var item = (missMain ? st.main : st.comp).item;
    var opt = ((item && item.getAttribute('data-option-name')) || '').toLowerCase();
    if (OPTION_ACC.indexOf(opt) === -1) opt = 'rozmiar';
    var noun = nounOf(item);
    var gen = NOUN_GEN[noun];
    var no = missMain ? '1. ' : '2. ';
    var what;
    if (!gen) what = no + 'produktu';
    else if (noun === nounOf(missMain ? st.comp.item : st.main.item)) what = no + gen;
    else what = gen;
    return 'Wybierz ' + opt + ' ' + what;
  }

  /* ============ Popup: stan (§3.2/§3.3) ============ */

  var active = null;          // sesja otwartego popupu
  var countedOnce = false;    // count-up oszczędności tylko przy pierwszym otwarciu na stronie
  var mainUserPicked = false; // klient sam zmienił rozmiar na karcie produktu (zdarzenie zaufane)
  var backPendingUntil = 0;   // popstate z naszego history.back() — ignorowany

  // Popup jest przenoszony do <body> (bindRoot), więc trzymamy referencję na roocie
  function getPopup(root) {
    return root.__bundlePopup || root.querySelector('[data-bundle-pop]');
  }

  function popItems(popup) {
    return {
      main: popup.querySelector('[data-bundle-item][data-role="main"]'),
      comp: popup.querySelector('[data-bundle-item][data-role="complement"]')
    };
  }

  function popTile(popup, role) {
    return popup ? popup.querySelector('.bundle-pop__tile[data-role="' + role + '"]') : null;
  }

  // Wybrany wariant kroku: produkt bez wariantów ma go od razu, pozostałe po wyborze rozmiaru
  function itemVariantId(item) {
    return parseInt(item.getAttribute('data-variant-id'), 10) || 0;
  }

  function selectRadio(item, radio) {
    radio.checked = true;
    item.setAttribute('data-variant-id', radio.value);
    item.setAttribute('data-price-cents', radio.getAttribute('data-price-cents') || '');
  }

  function labelFor(radio) {
    if (!radio) return null;
    if (radio.labels && radio.labels[0]) return radio.labels[0];
    var n = radio.nextElementSibling;
    return n && n.tagName === 'LABEL' ? n : null;
  }

  // §3.2: min/max po dostępnych rozmiarach; bez wyboru cena = min (gwarantowana „podłoga”)
  // unavailable = żaden rozmiar nie jest dostępny (wyprzedany produkt) — krok nie da się rozwiązać,
  // a ceny kafla bierzemy ze wszystkich rozmiarów, żeby nie pokazać „0 zł”
  function itemInfo(item) {
    var info = { item: item, single: false, resolved: false, unavailable: false, min: 0, max: 0, price: 0, exact: false, label: '', radio: null };
    if (!item) return info;
    if (item.getAttribute('data-single') === 'true') {
      var p = toInt(item.getAttribute('data-price-cents'));
      info.single = info.exact = true;
      info.unavailable = item.getAttribute('data-available') === 'false';
      info.resolved = !info.unavailable;
      info.min = info.max = info.price = p;
      info.label = 'Uniwersalny';
      return info;
    }
    var min = -1;
    var max = 0;
    var allMin = -1;
    var allMax = 0;
    var checked = null;
    $$('input[type="radio"]', item).forEach(function (r) {
      var c = toInt(r.getAttribute('data-price-cents'));
      if (allMin < 0 || c < allMin) allMin = c;
      if (c > allMax) allMax = c;
      if (r.disabled) return;
      if (min < 0 || c < min) min = c;
      if (c > max) max = c;
      if (r.checked && !checked) checked = r;
    });
    if (min < 0) {
      info.unavailable = true;
      min = Math.max(allMin, 0);
      max = allMax;
    }
    info.min = min;
    info.max = max;
    info.radio = checked;
    info.resolved = !!checked;
    info.price = checked ? toInt(checked.getAttribute('data-price-cents')) : info.min;
    info.exact = info.resolved || info.min === info.max;
    info.label = checked ? (checked.getAttribute('data-label') || checked.value) : '';
    return info;
  }

  function computeState(popup, root) {
    var items = popItems(popup);
    var main = itemInfo(items.main);
    var comp = itemInfo(items.comp);
    var B = toInt(root.getAttribute('data-bundle-cents'));
    var save = calcSave(main.price, comp.price, B);
    var add = B - main.price;
    var gratisOn = popFlag(popup, root, 'data-gratis-enabled', true);
    var soldOut = main.unavailable ? main : (comp.unavailable ? comp : null);
    return {
      main: main,
      comp: comp,
      B: B,
      unavailable: !!soldOut,
      soldOutTitle: soldOut && soldOut.item ? (soldOut.item.getAttribute('data-title') || '') : '',
      n: (main.resolved ? 1 : 0) + (comp.resolved ? 1 : 0),
      exact: main.exact && comp.exact,
      sum: main.price + comp.price,
      save: save,
      deal: B > 0 && save > 0,
      add: add,
      mode: add > 0 ? 'add' : (add === 0 && gratisOn ? 'gratis' : 'plain'),
      title: (items.comp && items.comp.getAttribute('data-title')) || ''
    };
  }

  function stateForN(n) {
    return n >= 2 ? 'ready' : (n === 1 ? 'partial' : 'empty');
  }

  // Wyprzedany produkt (żaden rozmiar) — tylko komunikat dla czytników; widoczne „Wyprzedane” niesie CTA
  // (stopka nie ma już tekstu statusu — instrukcję pokazuje CTA, zmiany ogłasza region live)
  function soldOutText(st) {
    return 'Wyprzedane: ' + st.soldOutTitle;
  }

  // Etykieta CTA (wielkie litery robi CSS): instrukcja → „Dodaj zestaw do koszyka” → „Dodajemy” → „Dodano”.
  // Suma jest w stopce po prawej (jak w widgecie kreatora), więc CTA jej nie powtarza.
  // „Dodajemy” bez wielokropka — kropki daje wskaźnik .bundle-pop__cta-busy; „✓” przy „Dodano” rysuje SVG (CSS)
  function ctaFor(state, st) {
    if (state === 'adding') return 'Dodajemy';
    if (state === 'added') return 'Dodano';
    if (st.unavailable) return 'Wyprzedane';
    if (state === 'error') return 'Spróbuj ponownie';
    if (st.n >= 2) return 'Dodaj zestaw do koszyka';
    return st.n === 1 ? missingLabel(st) : 'Wybierz rozmiary';
  }

  // Tytuł stopki (jak widget kreatora zestawów): „Wybierz 2 rozmiary” → „Wybierz jeszcze 1 rozmiar” → „Zestaw gotowy!”
  function footTitleFor(st) {
    if (st.unavailable) return 'Wyprzedane';
    var left = 2 - st.n;
    if (left <= 0) return 'Zestaw gotowy!';
    return left === 2 ? 'Wybierz 2 rozmiary' : 'Wybierz jeszcze 1 rozmiar';
  }

  function descFor(st) {
    var tail = st.n < 2 ? ' Wybierz rozmiar obu produktów.' : '';
    var head = 'Ten produkt i ' + st.title + ' razem ';
    if (!st.deal) return head + (st.exact ? 'za ' : 'od ') + fm(st.sum) + '.' + tail;
    if (st.exact) return head + 'za ' + fm(st.B) + ' zamiast ' + fm(st.sum) + '. Oszczędzasz ' + fm(st.save) + '.' + tail;
    return head + 'za ' + fm(st.B) + '. Oszczędzasz co najmniej ' + fm(st.save) + '.' + tail;
  }

  // Cena w kaflu: <b>kwota</b> <s>przekreślona</s> albo zwykły tekst
  function setPrice(el, main, old) {
    if (!el) return;
    var key = main + '|' + (old || '');
    if (el.__key === key) return;
    el.__key = key;
    el.textContent = '';
    if (old == null) {
      el.textContent = main;
      return;
    }
    var b = document.createElement('b');
    b.className = 'bundle-pop__price-now';
    b.textContent = main;
    var s = document.createElement('s');
    s.className = 'bundle-pop__price-old';
    // Czytniki pomijają <s> — „zamiast” tylko dla nich
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = 'zamiast ';
    s.appendChild(sr);
    s.appendChild(document.createTextNode(old));
    el.appendChild(b);
    el.appendChild(document.createTextNode(' '));
    el.appendChild(s);
  }

  // Ceny kolumn: oba kafle pokazują ceny regularne („189 zł”, „299 zł”) — matematykę zestawu (299 zamiast 488, −189)
  // niosą hero i stopka; v4.4 bez „110 zł” na kaflu (wyliczona dopłata była nieintuicyjna). Wyjątek: „Gratis ~~189 zł~~”
  function paintTiles(s, st) {
    var mainTile = popTile(s.popup, 'main');
    var compTile = popTile(s.popup, 'complement');
    setPrice(q(mainTile, '[data-tile-price]'), (st.main.exact ? '' : 'od ') + fm(st.main.price), null);

    var cPrice = q(compTile, '[data-tile-price]');
    if (st.deal && st.mode === 'gratis') {
      setPrice(cPrice, 'Gratis', fm(st.comp.price));
    } else {
      // Bez okazji (lub tryb plain) — zwykła cena, bez dopłaty
      setPrice(cPrice, (st.comp.exact ? '' : 'od ') + fm(st.comp.price), null);
    }
  }

  // Mikro-etykieta tuż nad wielką liczbą — mówi, co ta liczba znaczy (bez niej „189 ZŁ” czyta się jak cenę
  // bransoletki z rachunku niżej): „Oszczędzasz” / „Oszczędzasz co najmniej” (podłoga, dopóki rozmiary nie
  // przesądzają ceny); bez okazji liczba to suma — „Za oba” / „Za oba od”
  function heroLabel(st) {
    if (st.deal) return st.exact ? 'Oszczędzasz' : 'Oszczędzasz co najmniej';
    return st.exact ? 'Za oba' : 'Za oba od';
  }

  // Góra + liczba + podtytuł: mikro-etykieta okna, etykieta liczby, kwota dla czytników, nazwa okna (h2)
  function paintHead(s, st) {
    var popup = s.popup;
    var label = heroLabel(st);
    setText(q(popup, '[data-pop-kicker]'), 'Kupujesz razem');
    // Wiersz etykiety zawsze obecny (jedna linia) — zmiana dokładności podmienia tylko tekst, treść się nie przesuwa
    var pre = q(popup, '[data-pop-save-pre]');
    if (pre) {
      pre.hidden = false;
      setText(pre, label);
    }
    // Zdanie dla czytników (etykieta i cyfry count-upu są aria-hidden) — tylko przy zmianie stanu, nigdy co klatkę
    setText(q(popup, '[data-pop-save-sr]'), label + ' ' + fm(st.deal ? st.save : st.sum));
    var nouns = pairNouns(st);
    var title = st.deal ? 'Razem za ' + fm(st.B) : 'Kup razem';
    if (nouns) title = nouns + (st.deal ? ' za ' + fm(st.B) : '');
    setText(q(popup, '[data-pop-title]'), title);
  }

  // Rachunek: w hero przekreślona suma („zamiast 488 zł”), w stopce suma po prawej („299,00 zł” jak widget) oraz
  // zielone „Oszczędzasz 189,00 zł” + złota pigułka „39%” — tylko przy dokładnej cenie (po wyborze obu rozmiarów).
  // Bez okazji suma to „od …”, dopóki to podłoga — nigdy nie zaniżamy ceny do zapłaty; „zamiast” chowa CSS.
  function paintMath(s, st) {
    var popup = s.popup;
    // Skórka „para”: kwoty jak w bloku („299 zł”, nie „299,00 zł”) — krótsza linia oszczędności mieści „%” na telefonie
    var fmt = popup.getAttribute('data-skin') === 'para' ? fm : fmFull;
    var total = st.deal ? fmt(st.B) : (st.exact ? '' : 'od ') + fmt(st.sum);
    setText(q(popup, '[data-pop-math-old]'), fm(st.sum));
    var totalEl = q(popup, '[data-pop-math-total]');
    setText(totalEl, total);
    // v6.2 (skórka „para”): pod ceną za oba przekreślona suma regularna („zamiast 488 zł” było tylko w nagłówku)
    if (totalEl && fmt === fm && st.deal) {
      var was = document.createElement('s');
      was.className = 'bundle-pop__wtotal-old';
      was.textContent = (st.exact ? '' : 'od ') + fm(st.sum);
      totalEl.appendChild(was);
    }
    var showSave = st.deal && st.exact;
    var row = q(popup, '[data-pop-foot-save]');
    if (row) {
      row.hidden = !showSave;
      setText(q(row, '[data-pop-foot-save-amount]'), fmt(st.save));
    }
    // Procent zaokrąglony jak w kreatorze na kolekcji (fmtPercent, main-collection.liquid) — ta sama liczba w całym sklepie
    var pct = q(popup, '[data-pop-pct]');
    if (pct) {
      var showPct = showSave && st.sum > 0 && popFlag(popup, s.root, 'data-show-set-pct', true);
      pct.hidden = !showPct;
      if (showPct) setText(pct, Math.round(st.save * 100 / st.sum) + '%');
    }
    // Widoczna linia jest aria-hidden (czytniki pomijają <s>) — jedno zdanie zamiast niej
    var head = fm(st.main.price) + ' plus ' + fm(st.comp.price) + ': razem ';
    setText(q(popup, '[data-pop-math-sr]'), st.deal ? head + fm(st.B) + ' zamiast ' + fm(st.sum) + '.' : head + total + '.');
  }

  // Kroki i kafle: klasy stanu (wygląd i jednorazowe przejścia robi CSS)
  function paintItems(s, st) {
    var popup = s.popup;
    var next = !st.main.resolved && !st.main.unavailable ? st.main.item : (!st.comp.resolved && !st.comp.unavailable ? st.comp.item : null);
    [['main', st.main], ['complement', st.comp]].forEach(function (pair) {
      var role = pair[0];
      var info = pair[1];
      var item = info.item;
      var tile = popTile(popup, role);
      var done = info.resolved;
      var pickedVal = done ? info.label : '';

      if (item) {
        item.classList.toggle('is-done', done);
        item.classList.toggle('is-next', item === next);
        // Mikro-etykieta legendy: „ROZMIAR 18 CM” — wartość obok nazwy opcji
        var val = q(item, '[data-step-val]');
        if (val) {
          setText(val, pickedVal);
          val.hidden = !pickedVal;
        }
      }
      if (tile) tile.classList.toggle('is-done', done);
      // Karta jak w kreatorze: po wyborze złoty ring (.is-done na .bundle-pop__card)
      var card = tile ? tile.closest('.bundle-pop__card') : null;
      if (card) card.classList.toggle('is-done', done);
      // Awatar w stopce (jak widget kreatora): zdjęcie produktu po wyborze rozmiaru; pop-in tylko przy realnym
      // przejściu (s.last = poprzedni stan — przy otwarciu i ponownym malowaniu nic nie skacze)
      var av = q(popup, '[data-pop-avatar="' + role + '"]');
      if (av) {
        var im = q(av, 'img');
        var thumb = item ? item.getAttribute('data-thumb') || '' : '';
        if (im && thumb && im.getAttribute('src') !== thumb) im.setAttribute('src', thumb);
        av.classList.toggle('has-img', !!thumb);
        var wasDone = s.last ? (role === 'main' ? s.last.main.resolved : s.last.comp.resolved) : done;
        av.classList.toggle('is-filled', done);
        // v6.1 (skórka „para”): wybrany rozmiar na kółku produktu — jasne, który rozmiar jest czego
        if (popup.getAttribute('data-skin') === 'para') {
          // Sama liczba („20,5”) — kółka na siebie nachodzą, „cm” jest w legendzie rozmiarów
          var sz = done && info.label ? String(info.label).replace(/\s*cm\b/i, '').trim() : '';
          if (sz && !/\d/.test(sz)) sz = '\u2713';
          if (sz) av.setAttribute('data-size', sz);
          else av.removeAttribute('data-size');
        }
        if (done && !wasDone && !RM.matches) {
          av.classList.remove('is-pop');
          void av.offsetWidth;
          av.classList.add('is-pop');
        } else if (!done) {
          av.classList.remove('is-pop');
        }
      }
      // Złota plakietka „✓ 18 cm” w rogu zdjęcia
      var picked = q(tile, '[data-tile-picked]');
      if (picked) {
        picked.hidden = !done;
        setText(q(picked, '[data-tile-picked-val]'), pickedVal);
      }
    });
    // v6.1: nazwa pary w podsumowaniu (skórka „para”; test: w stopce brakowało nazw) — rozmiary są na kółkach
    var sizes = q(popup, '[data-pop-sizes]');
    if (sizes) {
      var mainNoun = popup.getAttribute('data-main-noun') || '';
      var ct = q(popup, '[data-col="complement"] .bundle-pop__title');
      var compName = ct ? ct.textContent.trim().replace(/^(Łańcuszek|Łańcuch|Bransoletka|Zawieszka)\s+/i, '') : '';
      var pairName = mainNoun && compName ? mainNoun + ' + ' + compName : '';
      setText(sizes, pairName);
      sizes.hidden = !pairName;
    }
  }

  // Statyczny obraz stanu; flags.animate + flags.lockNow = wejście w 2/2 (podmiana etykiety CTA)
  function paintPopup(s, st, flags) {
    var popup = s.popup;
    var state = s.state;
    flags = flags || {};
    var moving = !!flags.animate && !RM.matches;

    popup.setAttribute('data-state', state);
    popup.setAttribute('data-deal', st.deal ? 'true' : 'false');
    popup.setAttribute('data-mode', st.mode);
    // Dla CSS: 2/2 (linia pod „Razem” rośnie, „+” → „✓”, postęp i CTA złote), licznik wyborów, dokładne ceny
    popup.setAttribute('data-ready', st.n >= 2 && !st.unavailable ? 'true' : 'false');
    popup.setAttribute('data-count', String(st.n));
    popup.setAttribute('data-exact', st.exact ? 'true' : 'false');

    paintHead(s, st);
    paintMath(s, st);
    toggleHidden(q(popup, '[data-pop-note]'), !st.deal);
    setText(q(popup, '[data-pop-desc]'), descFor(st));

    paintTiles(s, st);
    paintItems(s, st);

    // Stopka (jak widget kreatora): tytuł „Wybierz 2 rozmiary” → „Zestaw gotowy!”, pasek postępu + licznik, CTA
    var ft = q(popup, '[data-pop-foot-title]');
    if (moving && flags.lockNow) swapText(s, ft, footTitleFor(st), 140);
    else putText(ft, footTitleFor(st));
    setText(q(popup, '[data-pop-count]'), st.n + '/2');
    var bar = q(popup, '[data-pop-bar]');
    if (bar) {
      bar.setAttribute('aria-valuenow', String(st.n));
      bar.setAttribute('aria-valuetext', st.n + ' z 2');
    }
    var fill = q(popup, '[data-pop-fill]');
    if (fill) fill.style.setProperty('--p', String(st.n / 2));

    var cta = q(popup, '[data-bundle-pop-add]');
    var label = q(popup, '[data-pop-cta-label]');
    var ctaText = ctaFor(state, st);
    // v6.3 (skórka „para”): gotowe CTA z ceną zestawu — „Dodaj zestaw za 299 zł”
    if (popup.getAttribute('data-skin') === 'para' && state === 'ready' && st.n >= 2 && !st.unavailable) {
      ctaText = 'Dodaj zestaw za ' + fm(st.deal ? st.B : st.sum);
    }
    if (cta) {
      cta.setAttribute('aria-disabled', st.n < 2 || st.unavailable || state === 'adding' || state === 'added' ? 'true' : 'false');
      cta.classList.toggle('is-long', ctaText.length > CTA_LONG);
    }
    if (moving && flags.lockNow) swapText(s, label, ctaText, 140);
    else putText(label, ctaText);
  }

  /* ============ Popup: kwota oszczędności (count-up tylko w górę) ============ */

  function stopCount(el) {
    if (el.__raf) cancelAnimationFrame(el.__raf);
    el.__raf = 0;
  }

  function setAmount(el, v) {
    stopCount(el);
    el.__val = v;
    el.textContent = fm(v);
  }

  function countUp(s, el, ghost, from, to, ms) {
    stopCount(el);
    if (ghost) ghost.textContent = fm(to);                     // rezerwuje docelową szerokość
    if (RM.matches || to <= from) { setAmount(el, to); return; } // nigdy nie liczymy w dół
    var t0 = performance.now();
    function f(now) {
      var p = Math.min(1, Math.max(0, (now - t0) / ms));
      var e = 1 - Math.pow(1 - p, 3);                           // easeOutCubic
      // Pełne złote w locie (zaokrąglone w dół i w granicach from…to — nigdy nie przeskakuje celu), dokładnie na końcu
      var raw = from + (to - from) * e;
      var v = p === 1 ? to : Math.min(to, Math.max(from, Math.floor(raw / 100) * 100));
      el.__val = v;
      el.textContent = fm(v);
      el.__raf = p < 1 ? requestAnimationFrame(f) : 0;
    }
    // Pierwsza klatka w następnym kadrze — wartość startowa (np. 0) nie zostaje narysowana sama
    el.__val = from;
    el.__raf = requestAnimationFrame(f);
    if (s.rafs.indexOf(el) === -1) s.rafs.push(el);
  }

  // how: 'first' (0 → kwota), 'open' / 'static' (od razu kwota), 'change' (w górę liczy, w dół podmienia)
  function renderAmount(s, st, how) {
    var live = q(s.popup, '[data-pop-save-amount]');
    var ghost = q(s.popup, '[data-pop-save-ghost]');
    if (!live) return;
    if (!st.deal) {
      // Bez okazji wielka liczba to suma (bez count-upu); kolejna okazja policzy w górę od zera
      stopCount(live);
      live.__val = 0;
      setText(live, fm(st.sum));
      if (ghost) ghost.textContent = fm(st.sum);
      return;
    }
    var to = st.save;
    var from = typeof live.__val === 'number' ? live.__val : 0;
    if (ghost) ghost.textContent = fm(to);

    if (RM.matches || how === 'static' || how === 'open') {
      setAmount(live, to);
      return;
    }
    if (how === 'first') {
      // Liczba pojawia się dopiero z count-upem (ghost trzyma szerokość) — bez wielkiego „0 zł” na wejściu;
      // start razem z wejściem wiersza liczby (CSS: bx-rise z opóźnieniem 90 ms)
      stopCount(live);
      live.__val = 0;
      live.textContent = '';
      later(s, function () {
        // Jeśli klient zdążył już coś wybrać, liczy zmiana — tu tylko aktualny cel
        if (live.__raf || live.__val !== 0 || !s.last || !s.last.deal) return;
        countUp(s, live, ghost, 0, s.last.save, COUNT_MS);
      }, 120);
      return;
    }
    if (to > from) countUp(s, live, ghost, from, to, COUNT_MS);
    // W dół — od razu; cel równy wartości w locie, gdy count-up wciąż biegnie do starszego, wyższego celu — też
    // od razu (inaczej wylądowałby na starej, zawyżonej kwocie)
    else if (to < from || live.__raf) setAmount(live, to);
  }

  /* ============ Popup: komunikaty, 2/2, walidacja ============ */

  function announce(s, text) {
    var live = q(s.popup, '[data-pop-live]');
    if (!live || !text) return;
    if (s.liveTimer) clearTimeout(s.liveTimer);
    s.liveTimer = later(s, function () {
      s.liveTimer = null;
      if (live.textContent === text) {
        live.textContent = '';
        later(s, function () { live.textContent = text; }, 60);
      } else {
        live.textContent = text;
      }
    }, 250);
  }

  function announceChange(s, prev, st, radio) {
    var info = radio.closest('[data-role="main"]') ? st.main : st.comp;
    var picked = 'Wybrano ' + info.label + '. ';
    var totals = st.deal ? 'Razem ' + fm(st.B) + ', oszczędzasz ' + fm(st.save) + '.' : 'Razem ' + fm(st.sum) + '.';
    if (st.n >= 2) announce(s, (prev && prev.n < 2 ? 'Gotowe. ' : picked) + totals);
    else if (st.n === 1) announce(s, picked + 'Jeszcze 1 rozmiar.');
    else announce(s, picked.trim());
  }

  function scrollStepIntoView(s, step, smooth) {
    var body = q(s.popup, '[data-pop-body]');
    if (!step || !body) return;
    var br = body.getBoundingClientRect();
    var r = step.getBoundingClientRect();
    if (r.top >= br.top && r.bottom <= br.bottom) return;
    try {
      step.scrollIntoView({ block: 'nearest', behavior: smooth && !RM.matches ? 'smooth' : 'auto' });
    } catch (e) {
      step.scrollIntoView(false);
    }
  }

  // Moment 2/2: „+” → „✓” (przenikanie), złota linia pod „Razem” rośnie, linie pod zdjęciami i postęp przechodzą
  // w złoto — CSS na .is-lockin (nie na data-ready: przy otwarciu od razu w 2/2 data-ready jest ustawione, zanim
  // arkusz się pokaże, więc moment by nie zagrał). CTA złote od data-state. Tu tylko klasa chwili i haptyka;
  // bez pompowania i sprężyn. Podmianę etykiety CTA robi paintPopup. d = opóźnienie (450 ms, gdy popup otwiera
  // się od razu gotowy — po wejściu treści)
  function lockIn(s, d) {
    if (s.lockedIn) return;
    s.lockedIn = true;
    var run = function () {
      if (s !== active || s.closing || !s.lockedIn) return;
      s.popup.classList.add('is-lockin');
      haptic(10);
    };
    if (d) later(s, run, d);
    else run();
  }

  // Zejście poniżej 2/2 (np. wyprzedany rozmiar po 422) — przy ponownym 2/2 moment zagra od nowa
  function unlock(s) {
    s.lockedIn = false;
    s.popup.classList.remove('is-lockin');
  }

  // Błąd kroku: tekst pod rozmiarami + aria-invalid na grupie; opis błędu podpięty do radiów tylko, gdy jest widoczny
  function setItemError(item, show) {
    item.classList.toggle('is-invalid', !!show);
    var err = item.querySelector('[data-item-error]');
    if (err) err.hidden = !show;
    if (show) item.setAttribute('aria-invalid', 'true');
    else item.removeAttribute('aria-invalid');
    var errId = err && err.id;
    $$('input[type="radio"]', item).forEach(function (r) {
      if (show && errId) r.setAttribute('aria-describedby', errId);
      else r.removeAttribute('aria-describedby');
    });
  }

  // CTA przy n < 2: komunikat pod rozmiarami brakującej kolumny (czerwone pigułki + rosnąca czerwona linia w CSS),
  // region live, przewinięcie i fokus na pierwszym dostępnym rozmiarze — bez drgania (brandbook: nic sprężystego)
  function nudgeMissing(s, missing) {
    if (!missing.length) return;
    var popup = s.popup;
    var rm = RM.matches;
    var cta = q(popup, '[data-bundle-pop-add]');

    missing.forEach(function (item) {
      // Ponowne nadanie klasy odtwarza przejście CSS (linia rośnie od nowa) przy kolejnym tapnięciu
      item.classList.remove('is-invalid');
      void item.offsetWidth;
      setItemError(item, true);
    });

    var first = missing[0];
    var title = first.getAttribute('data-title') || '';
    var opt = (first.getAttribute('data-option-name') || 'Rozmiar').toLowerCase();
    var text = 'Wybierz ' + opt + ': ' + title;
    announce(s, text + '.');

    try {
      first.scrollIntoView({ block: 'nearest', behavior: rm ? 'auto' : 'smooth' });
    } catch (e) {
      first.scrollIntoView(false);
    }
    later(s, function () {
      var radio = first.querySelector('input[type="radio"]:not(:disabled)');
      focusEl(radio || cta);
    }, rm ? 0 : 320);
  }

  // Pełny render popupu: liczby + stan (+ podmiany tekstu, count-up, komunikat)
  function renderPopup(popup, root, opts) {
    var s = active;
    if (!s || s.popup !== popup) return null;
    opts = opts || {};
    var st = computeState(popup, root);
    var prev = s.last;
    var animate = !!(opts.animate && prev);

    if (opts.force || (s.state !== 'adding' && s.state !== 'added')) s.state = stateForN(st.n);
    var lockNow = animate && prev.n < 2 && st.n >= 2 && !s.lockedIn;
    if (st.n < 2 && s.lockedIn) unlock(s);

    paintPopup(s, st, { animate: animate, lockNow: lockNow });

    if (opts.amount !== 'none') renderAmount(s, st, animate ? 'change' : 'static');
    if (opts.announce && opts.radio) announceChange(s, prev, st, opts.radio);

    // Brakujący krok przewija się do widoku 250 ms po wyborze
    if (animate && opts.radio && st.n === 1) {
      var miss = !st.main.resolved ? st.main.item : st.comp.item;
      later(s, function () { scrollStepIntoView(s, miss, true); }, 250);
    }

    s.last = st;
    if (lockNow) lockIn(s, 0);
    return st;
  }

  function hideFormError(popup) {
    var el = q(popup, '[data-pop-error]');
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  function onRadioChange(e) {
    var radio = e.target;
    if (!radio || radio.type !== 'radio') return;
    var s = active;
    var item = radio.closest('[data-bundle-item]');
    if (!s || !item || !s.popup.contains(item) || s.closing) return;
    if (s.state === 'adding' || s.state === 'added') return;

    selectRadio(item, radio);
    item.__endowed = false;
    if (s.popup.getAttribute('data-skin') === 'para') rememberPick(s, item, radio);
    setItemError(item, false);
    hideFormError(s.popup);
    renderPopup(s.popup, s.root, { animate: true, radio: radio, announce: true });
  }

  // v6.1 (skórka „para”): rozmiary wybrane w oknie wracają przy ponownym otwarciu — porównywanie łańcuchów bez
  // klikania wszystkiego od nowa. Klucz: produkt ze strony albo uchwyt dobieranego; zmiana rozmiaru na PDP czyści „main”
  function pickKey(s, item) {
    if (item.getAttribute('data-role') === 'main') return 'main';
    return 'comp:' + ((s.card && s.card.getAttribute('data-pair-pick')) || '');
  }

  function rememberPick(s, item, radio) {
    var m = s.root.__paraPicks || (s.root.__paraPicks = {});
    m[pickKey(s, item)] = radio.value;
  }

  function restorePicks(s, items) {
    var m = s.root.__paraPicks;
    if (!m) return;
    [items.main, items.comp].forEach(function (item) {
      if (!item || item.getAttribute('data-single') === 'true' || item.getAttribute('data-variant-id')) return;
      var v = m[pickKey(s, item)];
      var radio = v ? item.querySelector('input[type="radio"][value="' + v + '"]') : null;
      if (radio && !radio.disabled) {
        selectRadio(item, radio);
        item.__endowed = true;
      }
    });
  }

  /* ============ Popup: otwieranie i zamykanie ============ */

  function newSession(root, popup, card, trigger) {
    return {
      root: root,
      popup: popup,
      dialog: popup.querySelector('.bundle-pop__dialog'),
      card: card,
      trigger: trigger || null,
      timers: [],
      rafs: [],
      anims: [],
      flipAnims: [],
      flipCleanup: null,
      inerted: [],
      pushed: false,
      state: 'empty',
      last: null,
      lockedIn: false,
      liveTimer: null,
      closing: false,
      finished: false,
      reason: null,
      closeTimer: null,
      onEnd: null,
      openedAt: Date.now(),
      // Znacznik wpisu historii tego otwarcia (popstate rozpoznaje własny wpis)
      token: newBundleUid()
    };
  }

  // Wpis historii dodawany przy otwarciu („Wstecz” zamyka arkusz)
  function historyEntry(s) {
    return { bundlePop: s.popup.getAttribute('data-bundle-pop-for') || s.popup.id || true, t: s.token };
  }

  // Treść przewinięta → włosowa linia pod górą okna (CSS: .bundle-pop__dialog.is-scrolled)
  function syncScrolled(s) {
    var body = q(s.popup, '[data-pop-body]');
    if (s.dialog) s.dialog.classList.toggle('is-scrolled', !!body && body.scrollTop > 0);
  }

  // Tytuły kolumn: wysokość dwóch linii tylko, gdy któryś naprawdę się łamie — ceny i rozmiary obu kolumn
  // w jednej linii, bez pustego miejsca pod krótkimi nazwami. Pomiar wymaga układu (popup widoczny)
  function syncTitles(popup) {
    var wrap = q(popup, '.bundle-pop__products');
    if (!wrap || popup.hidden) return;
    wrap.classList.remove('is-tall');
    var tall = $$('.bundle-pop__title', wrap).some(function (t) {
      var lh = parseFloat(window.getComputedStyle(t).lineHeight) || 0;
      return lh > 0 && t.offsetHeight > lh * 1.5;
    });
    wrap.classList.toggle('is-tall', tall);
  }

  function cancelSession(s) {
    s.timers.forEach(clearTimeout);
    s.timers = [];
    s.rafs.forEach(stopCount);
    s.rafs = [];
    cancelFlip(s);
    s.anims.slice().forEach(function (a) { try { a.cancel(); } catch (e) {} });
    s.anims = [];
    s.liveTimer = null;
  }

  // Przelot karta → kafel (klon na <body>); anulowanie usuwa klon i odsłania kafel
  function cancelFlip(s) {
    var list = s.flipAnims;
    s.flipAnims = [];
    list.forEach(function (a) { try { a.cancel(); } catch (e) {} });
    // Zdarzenie „cancel” WAAPI przychodzi dopiero z następną klatką — klon usuwamy od razu
    if (s.flipCleanup) {
      var fn = s.flipCleanup;
      s.flipCleanup = null;
      fn();
    }
  }

  // Strona pod popupem nieaktywna (czytniki, Tab, klik); popup i klon FLIP zostają aktywne
  function applyInert(s) {
    s.inerted = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === s.popup || el.hasAttribute('data-bundle-flip')) return;
      // Baner zgody na cookies (Shopify, z-index nad popupem) musi dać się kliknąć — inaczej zasłania CTA
      if (el.id === 'shopify-pc__banner') return;
      if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName)) return;
      if (el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      s.inerted.push(el);
    });
  }

  function releaseInert(s) {
    s.inerted.forEach(function (el) { el.removeAttribute('inert'); });
    s.inerted = [];
  }

  function setFieldsetsDisabled(popup, disabled) {
    $$('[data-bundle-item]', popup).forEach(function (f) { f.disabled = !!disabled; });
  }

  function resetCta(popup) {
    var cta = q(popup, '[data-bundle-pop-add]');
    if (!cta) return;
    cta.disabled = false;
    cta.removeAttribute('aria-busy');
    cta.classList.remove('is-busy');
  }

  function showFormError(s, msg) {
    var el = q(s.popup, '[data-pop-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function currentMainVariantId(root) {
    if (root.__mainVariant && root.__mainVariant.id) return Number(root.__mainVariant.id);
    var form = getMainProductForm();
    if (!form) return 0;
    // getAttribute: form.id zwraca pole <input name="id"> (nazwane pole przesłania właściwość formularza)
    var fid = form.getAttribute('id');
    var sel = form.querySelector('[name="id"]') || (fid && document.querySelector('[name="id"][form="' + fid + '"]'));
    return sel ? toInt(sel.value) : 0;
  }

  // Kolor tła pola zdjęcia (przezroczyste → dflt) — klon FLIP przechodzi z tła karty w tło kafla (#F5F5F5)
  function solidBg(el, dflt) {
    var c = el ? window.getComputedStyle(el).backgroundColor : '';
    if (!c || c === 'transparent' || /^rgba\(.*,\s*0\)$/.test(c)) return dflt;
    return c;
  }

  // FLIP, krok 1: zdjęcie karty (mierzone, zanim html.bundle-pop-open schowa pasek przewijania)
  function flipSource(card) {
    if (RM.matches || !HAS_WAAPI || isLowEnd() || !card) return null;
    var img = card.querySelector('.bundle-upsell__media img');
    if (!img || !img.complete || !img.naturalWidth) return null;
    var box = card.querySelector('.bundle-upsell__media');
    var from = img.getBoundingClientRect();
    if (!from.width || !from.height) from = (box || img).getBoundingClientRect();
    if (!intersectsViewport(from)) return null;
    // v6.11: padding zdjęcia i zaokrąglenie pola — klon wygląda dokładnie jak kafel na starcie.
    // Padding w px: klon jest position:fixed, więc procent liczyłby się od szerokości okna, nie klonu
    // (4% dawało 15px na telefonie i 51px na desktopie zamiast 5,7px — zdjęcie w locie było za małe).
    var ics = window.getComputedStyle(img);
    var padPx = parseFloat(ics.paddingLeft) || 0;
    var radius = box ? parseFloat(window.getComputedStyle(box).borderTopLeftRadius) || 0 : 0;
    return { img: img, from: from, bg: solidBg(box, '#fff'), padPx: padPx, radius: radius };
  }

  // FLIP, krok 2: docelowy kafel „Dobierasz” (dialog bez transformacji, już w końcowym układzie)
  function measureFlip(src, popup, dialog) {
    if (!src || !dialog) return null;
    var img = src.img;
    var from = src.from;
    var target = q(popTile(popup, 'complement'), '.bundle-pop__media');
    if (!target) return null;

    dialog.style.transition = 'none';
    dialog.style.transform = 'none';
    var tImg = q(target, 'img');
    var to = tImg ? tImg.getBoundingClientRect() : null;
    // Tło kafla i ewentualne mix-blend-mode zdjęcia — klon wygląda jak kafel w chwili lądowania
    var toBg = solidBg(target, src.bg);
    var blend = tImg ? window.getComputedStyle(tImg).mixBlendMode : '';
    if (!to || !to.width || !to.height) {
      to = target.getBoundingClientRect();
    }
    // v6.11: klon ma ten sam padding co zdjęcia (4%), więc ląduje na całym polu zdjęcia — obrazek trafia w obrazek
    var toRadius = parseFloat(window.getComputedStyle(target).borderTopLeftRadius) || 0;
    // Hero nad kartami może zepchnąć cel pod stopkę na niskich telefonach — wtedy bez przelotu (klon nie leci pod spód)
    var body = q(popup, '[data-pop-body]');
    var br = body ? body.getBoundingClientRect() : null;
    var visible = !br || (to.top >= br.top - 1 && to.top + to.height <= br.bottom + 1);
    dialog.style.transform = '';
    void dialog.offsetWidth;
    dialog.style.transition = '';
    if (!visible) return null;
    if (!to.width || !to.height || !from.width || !from.height) return null;
    return { img: img, from: from, to: to, target: target, fromBg: src.bg, toBg: toBg, blend: blend, padPx: src.padPx || 0, fromRadius: src.radius || 0, toRadius: toRadius };
  }

  // Zdjęcie kafla gotowe do pokazania (kafel ma inne sizes niż karta → inny plik z srcset); nigdy nie odrzuca
  function imgReady(img) {
    if (!img) return Promise.resolve();
    if (typeof img.decode === 'function') return img.decode().then(null, function () {});
    if (img.complete && img.naturalWidth) return Promise.resolve();
    return new Promise(function (resolve) {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  }

  // Zdjęcie z karty leci do kafla (400 ms, jedna krzywa marki ease-out — limit ruchu ≤ 400 ms), potem klon gaśnie,
  // a kafel się pojawia (100 ms).
  // Skala jednolita (bez rozciągania przy innych proporcjach kafla, np. 16:10 na niskich ekranach),
  // klon wyśrodkowany w polu kafla; przenikanie dopiero, gdy zdjęcie kafla jest gotowe (czekamy najwyżej 300 ms).
  function flipFromCard(s, m) {
    var clone = document.createElement('div');
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-bundle-flip', '');
    var fromBg = m.fromBg || '#fff';
    var toBg = m.toBg || fromBg;
    clone.style.cssText = 'position:fixed;margin:0;left:' + m.from.left + 'px;top:' + m.from.top + 'px;width:' + m.from.width + 'px;height:' + m.from.height + 'px;z-index:10061;border-radius:' + (m.fromRadius || 0) + 'px;overflow:hidden;background:' + fromBg + ';transform-origin:0 0;pointer-events:none;box-sizing:border-box;padding:' + (m.padPx || 0) + 'px;';
    var img = document.createElement('img');
    img.alt = '';
    img.src = m.img.currentSrc || m.img.src;
    img.style.cssText = 'display:block;width:100%;height:100%;max-width:none;object-fit:contain;';
    // Jak w kafelku (np. multiply na #F5F5F5) — klon stapia się z tłem tak samo, bez białego prostokąta przy lądowaniu
    if (m.blend && m.blend !== 'normal') img.style.mixBlendMode = m.blend;
    clone.appendChild(img);
    document.body.appendChild(clone);

    var k = Math.min(m.to.width / m.from.width, m.to.height / m.from.height);
    var dx = m.to.left + (m.to.width - m.from.width * k) / 2 - m.from.left;
    var dy = m.to.top + (m.to.height - m.from.height * k) / 2 - m.from.top;
    var end = 'translate(' + dx + 'px,' + dy + 'px) scale(' + k + ')';
    // Zaokrąglenie przed skalą: na końcu po przeskalowaniu równe zaokrągleniu pola w oknie
    var endRadius = k ? (m.toRadius || 0) / k : 0;
    var tImgEl = q(m.target, 'img') || m.target;
    var ready = imgReady(q(m.target, 'img'));
    var hold = null;
    var cleanup = function () {
      if (s.flipCleanup === cleanup) s.flipCleanup = null;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      if (hold) {
        var h = hold;
        hold = null;
        try { h.cancel(); } catch (e) {}
      }
    };
    s.flipCleanup = cleanup;

    // Zdjęcie kafla niewidoczne, dopóki klon nie wyląduje (samo zdjęcie — białe pole zostaje, w ciemnym oknie nie ma dziury)
    hold = anim(tImgEl, [{ opacity: 0 }, { opacity: 0 }], { duration: 400, fill: 'forwards' }, s.flipAnims);
    // Tło klonu przechodzi z tła karty w tło kafla w trakcie lotu (mały element — koszt pomijalny)
    var fly = anim(clone, [
      { transform: 'translate(0px,0px) scale(1)', backgroundColor: fromBg, borderRadius: (m.fromRadius || 0) + 'px' },
      { transform: end, backgroundColor: toBg, borderRadius: endRadius + 'px' }
    ], { duration: 400, easing: EASE_OUT, fill: 'forwards' }, s.flipAnims);
    if (!fly) {
      cleanup();
      return;
    }
    fly.addEventListener('cancel', cleanup);
    fly.addEventListener('finish', function () {
      Promise.race([ready, wait(300)]).then(function () {
        if (!clone.parentNode) return;
        if (s !== active || s.closing) {
          cleanup();
          return;
        }
        anim(tImgEl, [{ opacity: 0 }, { opacity: 1 }], { duration: 100, easing: 'linear' }, s.flipAnims);
        if (hold) {
          var h = hold;
          hold = null;
          try { h.cancel(); } catch (e) {}
        }
        var fade = anim(clone, [{ opacity: 1 }, { opacity: 0 }], { duration: 100, easing: 'linear', fill: 'forwards' }, s.flipAnims);
        if (fade) {
          fade.addEventListener('finish', cleanup);
          fade.addEventListener('cancel', cleanup);
        } else {
          cleanup();
        }
      });
    });
    // Zabezpieczenie: klon nigdy nie zostaje na stronie, kafel nigdy nie zostaje niewidoczny
    setTimeout(cleanup, 1500);
  }

  // Wejście: FLIP zdjęcia karty do kafla „Dobierasz” i kwota (count-up); reszta wejścia (overlay, arkusz,
  // kolejne wejście treści co 50 ms: góra, liczba, podtytuł, rachunek, kolumny, stopka) to CSS na data-open="true".
  // Bez przelotu kolumna „Dobierasz” wchodzi razem z resztą (CSS); przy przelocie popup ma .is-flip.
  function choreograph(s, st, flip, reopening) {
    var first = !countedOnce;
    countedOnce = true;

    if (RM.matches) {
      renderAmount(s, st, 'static');
      return;
    }
    renderAmount(s, st, first && !reopening ? 'first' : 'open');
    if (reopening) return;
    if (flip) flipFromCard(s, flip);
  }

  function openPopup(root, card, trigger) {
    var popup = getPopup(root);
    if (!popup || !card) return;
    warmPopupImages(popup);
    var tpl = card.querySelector('template[data-bundle-item-tpl]');
    var tileSlot = popup.querySelector('[data-pop-slot="comp-tile"]');
    var stepSlot = popup.querySelector('[data-pop-slot="comp-step"]');
    var anySlot = popup.querySelector('[data-bundle-pop-slot]');
    if (!tpl || (!(tileSlot && stepSlot) && !anySlot)) return;

    // Ponowne otwarcie w trakcie zamykania przejmuje ten sam popup (przejście CSS się odwraca)
    var reopening = false;
    if (active) {
      if (!active.closing) return;
      if (active.popup === popup) {
        reopening = !popup.hidden;
        abortClose(active);
      } else {
        finishClose(active);
      }
    }

    var s = newSession(root, popup, card, trigger);
    active = s;
    popup.classList.remove('is-lockin');

    // 1. Świeże sloty z szablonu karty; każde otwarcie od zera
    var frag = tpl.content.cloneNode(true);
    var tilePart = frag.querySelector('[data-part="tile"]');
    var stepPart = frag.querySelector('[data-part="step"]');
    if (tileSlot && stepSlot) {
      tileSlot.textContent = '';
      stepSlot.textContent = '';
      if (tilePart) tileSlot.appendChild(tilePart);
      if (stepPart) stepSlot.appendChild(stepPart);
      else {
        var step = frag.querySelector('[data-bundle-item]');
        if (step) stepSlot.appendChild(step);
      }
    } else {
      anySlot.textContent = '';
      anySlot.appendChild(frag);
    }

    var items = popItems(popup);
    [items.main, items.comp].forEach(function (item) {
      if (!item) return;
      item.disabled = false;
      item.__endowed = false;
      setItemError(item, false);
      item.classList.remove('is-done', 'is-next');
      if (item.getAttribute('data-single') !== 'true') {
        $$('input[type="radio"]', item).forEach(function (r) { r.checked = false; });
        item.removeAttribute('data-variant-id');
        item.removeAttribute('data-price-cents');
      }
    });
    hideFormError(popup);
    resetCta(popup);
    setText(q(popup, '[data-pop-live]'), '');
    // Ponowne otwarcie w trakcie zamykania (popup widoczny) — tu działa od razu; ukryty popup: po odsłonięciu (krok 4)
    var body = q(popup, '[data-pop-body]');
    if (body) body.scrollTop = 0;
    syncScrolled(s);

    // 2. Rozmiar wybrany przez klienta na karcie produktu (tylko po zaufanej zmianie, gdy blok pozwala)
    if (items.main && mainUserPicked && popFlag(popup, root, 'data-preselect-main', true)) {
      var vid = currentMainVariantId(root);
      var radio = vid ? items.main.querySelector('input[type="radio"][value="' + vid + '"]') : null;
      if (radio && !radio.disabled) {
        selectRadio(items.main, radio);
        items.main.__endowed = true;
      }
    }

    if (popup.getAttribute('data-skin') === 'para') restorePicks(s, items);

    // 3. Stan bez animacji (liczby, podtytuł, rachunek, CTA)
    var st = renderPopup(popup, root, { force: true, amount: 'none' });

    // 4. Zdjęcie karty, klasa na <html> (bez przewijania strony), pokaż, zmierz cel FLIP,
    //    reflow, dopiero potem data-open=true (przejście CSS)
    var src = reopening ? null : flipSource(card);
    document.documentElement.classList.add('bundle-pop-open');
    var flip = null;
    if (!reopening) {
      popup.hidden = false;
      // Treść od góry dopiero po odsłonięciu (w ukrytym popupie scrollTop nic nie zmienia — zostawała pozycja
      // z poprzedniej sesji i liczba otwierała się ucięta); przed pomiarem FLIP i tytułów
      if (body) body.scrollTop = 0;
      syncScrolled(s);
      syncTitles(popup);
      flip = measureFlip(src, popup, s.dialog);
      // .is-flip przed data-open: kolumna „Dobierasz” wchodzi wtedy samym przenikaniem (bez przesunięcia),
      // bo zdjęcie ląduje w zmierzonym miejscu. Przy ponownym otwarciu w trakcie zamykania — bez zmian (CSS nie restartuje)
      popup.classList.toggle('is-flip', !!flip);
      void popup.offsetWidth;
    } else {
      syncTitles(popup);
    }
    popup.setAttribute('data-open', 'true');

    // 5. Choreografia; oba produkty bez rozmiarów = gotowe od razu, moment 2/2 po 450 ms
    choreograph(s, st, flip, reopening);
    if (st && st.n >= 2) lockIn(s, 450);

    // 6. inert, historia, fokus na tytule (podtytuł h2 = nazwa okna)
    applyInert(s);
    if (HISTORY_CLOSE && window.history && history.pushState) {
      try {
        history.pushState(historyEntry(s), '');
        s.pushed = true;
      } catch (e) {}
    }
    focusEl(q(popup, '[data-pop-title]') || q(popup, '.bundle-pop__close'));
  }

  // Zwraca true, gdy wywołano history.back() (refresh koszyka wtedy 60 ms później)
  function closePopup(root, opts) {
    var s = active;
    if (!s || (root && s.root !== root) || s.closing) return false;
    var reason = (opts && opts.reason) || 'dismiss';
    if (s.state === 'adding') return false;
    if (s.state === 'added' && reason !== 'added') return false;

    s.closing = true;
    s.reason = reason;
    s.popup.setAttribute('data-open', 'closing');
    // Przelot z karty nie leci dalej do zjeżdżającego kafla (reszta animacji gaśnie po ukryciu)
    cancelFlip(s);

    // Od razu: drawer koszyka musi móc złapać fokus
    releaseInert(s);
    document.documentElement.classList.remove('bundle-pop-open');

    var wentBack = false;
    if (s.pushed) {
      s.pushed = false;
      if (reason !== 'popstate') {
        try {
          backPendingUntil = Date.now() + 1000;
          history.back();
          wentBack = true;
        } catch (e) {
          backPendingUntil = 0;
        }
      }
    }

    var dialog = s.dialog;
    s.onEnd = function (e) {
      if (e.target !== dialog || (e.propertyName !== 'transform' && e.propertyName !== 'opacity')) return;
      finishClose(s);
    };
    if (dialog) dialog.addEventListener('transitionend', s.onEnd);
    s.closeTimer = setTimeout(function () { finishClose(s); }, 340);
    return wentBack;
  }

  function detachClose(s) {
    clearTimeout(s.closeTimer);
    s.closeTimer = null;
    if (s.dialog && s.onEnd) s.dialog.removeEventListener('transitionend', s.onEnd);
    s.onEnd = null;
  }

  function abortClose(s) {
    detachClose(s);
    s.finished = true;
    cancelSession(s);
    if (active === s) active = null;
  }

  function finishClose(s) {
    if (s.finished) return;
    s.finished = true;
    s.closing = true;
    detachClose(s);
    releaseInert(s);

    var popup = s.popup;
    popup.hidden = true;
    popup.setAttribute('data-open', 'false');
    popup.classList.remove('is-lockin', 'is-flip');
    // Animacje WAAPI anulujemy dopiero po ukryciu, żeby nie zerwać przejścia CSS
    cancelSession(s);
    resetCta(popup);
    setFieldsetsDisabled(popup, false);
    if (active === s) active = null;

    // Po dodaniu fokus przejmuje drawer koszyka
    if (s.reason !== 'added' && s.trigger && document.body.contains(s.trigger)) focusEl(s.trigger);
  }

  // Natychmiastowe zamknięcie (przeładowanie sekcji, duplikat popupu)
  function forceClose(s) {
    if (s.finished) return;
    if (!s.closing) document.documentElement.classList.remove('bundle-pop-open');
    s.pushed = false;
    s.reason = 'unload';
    finishClose(s);
  }

  // Pułapka Tab (zapasowa dla przeglądarek bez inert); radio — jedno na grupę jak natywnie
  function trapTab(e) {
    if (e.key !== 'Tab' || !active || active.closing) return;
    var dialog = active.dialog;
    if (!dialog) return;
    var groups = {};
    var nodes = $$('button:not(:disabled), input:not(:disabled), [href], [tabindex]:not([tabindex="-1"])', dialog).filter(function (el) {
      if (!el.getClientRects().length) return false;
      if (el.type !== 'radio') return true;
      if (groups[el.name]) return false;
      var group = $$('input[type="radio"]', dialog).filter(function (r) { return r.name === el.name && !r.disabled; });
      var pick = group.filter(function (r) { return r.checked; })[0] || group[0];
      if (el !== pick) return false;
      groups[el.name] = true;
      return true;
    });
    if (!nodes.length) {
      e.preventDefault();
      return;
    }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var cur = document.activeElement;
    var outside = !dialog.contains(cur);
    // Tytuł (fokus po otwarciu) przed wszystkimi kontrolkami → Shift+Tab z niego zawija na koniec;
    // v2.3: zamknięcie stoi w DOM przed tytułem, więc tam Shift+Tab działa natywnie (trafia w „Zamknij”)
    var title = q(dialog, '[data-pop-title]');
    var titleLeads = !!(title && (title.compareDocumentPosition(first) & 4));
    if (e.shiftKey) {
      if (outside || cur === first || (cur === title && titleLeads)) {
        e.preventDefault();
        focusEl(last);
      }
    } else if (outside || cur === last) {
      e.preventDefault();
      focusEl(first);
    }
  }

  /* ============ Dodanie do koszyka (§3.6) ============ */

  // Mint z jedną powtórką po 800 ms; nigdy nie odrzuca
  // expectCode = para daje oszczędność; bez niej brak kodu to poprawna odpowiedź workera —
  // wtedy jedna próba, bez powtórki i bez „bundle:discount-failed”
  function mintWithRetry(bundleKey, variantIds, expectCode) {
    if (!bundleKey) return Promise.resolve({ code: null, failed: false, settledAt: Date.now() });
    if (!expectCode) {
      return mintBundleCode(bundleKey, variantIds).then(function (code) {
        return { code: code || null, failed: false, settledAt: Date.now() };
      }, function (err) {
        console.warn('[bundle-upsell] mint (no deal) failed', err);
        return { code: null, failed: false, settledAt: Date.now() };
      });
    }

    function attempt() {
      return mintBundleCode(bundleKey, variantIds).then(function (code) {
        if (!code) throw new Error('mint: empty code');
        return code;
      });
    }

    return attempt()
      .catch(function (err) {
        console.warn('[bundle-upsell] mint failed, retrying', err);
        return wait(800).then(attempt);
      })
      .then(function (code) {
        return { code: code, failed: false, settledAt: Date.now() };
      }, function (err) {
        console.warn('[bundle-upsell] mint failed, continuing without code', err);
        return { code: null, failed: true, settledAt: Date.now() };
      });
  }

  // 422: który z wybranych wariantów właśnie się wyprzedał.
  // Najwyżej 4 s — popup w stanie „adding” nie da się zamknąć, więc zawieszone zapytanie = ogólny komunikat
  function identifySoldOut(s) {
    var items = popItems(s.popup);
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var lookup = Promise.all([items.main, items.comp].map(function (item) {
      if (!item || item.getAttribute('data-single') === 'true') return null;
      var handle = item.getAttribute('data-handle');
      var vid = itemVariantId(item);
      if (!handle || !vid) return null;
      return fetch(base + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) {
          var v = p && (p.variants || []).filter(function (x) { return Number(x.id) === vid; })[0];
          return v && v.available === false ? { item: item, vid: vid } : null;
        })
        .catch(function () { return null; });
    })).then(function (list) {
      return list.filter(Boolean);
    });
    return Promise.race([lookup, wait(4000).then(function () { return []; })]);
  }

  function markSoldOut(radio) {
    if (!radio) return;
    radio.checked = false;
    radio.disabled = true;
    var label = labelFor(radio);
    if (label && !label.querySelector('[data-soldout]')) {
      // Widoczne „brak” zamiast dopłaty — jak przy rozmiarze wyprzedanym już przy renderze (P31)
      var delta = label.querySelector('.bundle-pop__size-d');
      if (delta) delta.parentNode.removeChild(delta);
      var none = document.createElement('small');
      none.className = 'bundle-pop__size-d bundle-pop__size-x';
      none.setAttribute('aria-hidden', 'true');
      none.textContent = 'brak';
      label.appendChild(none);
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.setAttribute('data-soldout', '');
      sr.textContent = ' – wyprzedane';
      label.appendChild(sr);
    }
  }

  function resetSoldOut(s, hit) {
    var sel = 'input[type="radio"][value="' + hit.vid + '"]';
    markSoldOut(hit.item.querySelector(sel));
    // Szablon karty też — kolejne otwarcie nie pokaże tego rozmiaru jako dostępnego
    var tpl = hit.item.getAttribute('data-role') === 'complement' && s.card ? s.card.querySelector('template[data-bundle-item-tpl]') : null;
    if (tpl) markSoldOut(tpl.content.querySelector(sel));
    hit.item.removeAttribute('data-variant-id');
    hit.item.removeAttribute('data-price-cents');
    hit.item.__endowed = false;
  }

  // Stan błędu: komunikat w stopce (bez okienek przeglądarki), fokus na CTA, wybory zostają — bez drgania
  function failAdd(s, msg, keepState) {
    var popup = s.popup;
    var cta = q(popup, '[data-bundle-pop-add]');
    resetCta(popup);
    setFieldsetsDisabled(popup, false);
    if (!keepState) {
      s.state = 'error';
      paintPopup(s, computeState(popup, s.root));
    }
    showFormError(s, msg);
    focusEl(cta);
  }

  function onAddError(s, err) {
    if (s.finished || active !== s) return;
    var status = err && err.status;
    var desc = (err && err.description) || '';

    if (status === 422) {
      identifySoldOut(s).then(function (hits) {
        if (s.finished || active !== s) return;
        if (hits.length) {
          hits.forEach(function (hit) { resetSoldOut(s, hit); });
          resetCta(s.popup);
          setFieldsetsDisabled(s.popup, false);
          renderPopup(s.popup, s.root, { force: true, animate: true });
          failAdd(s, 'Ten rozmiar właśnie się wyprzedał. Wybierz inny.', true);
        } else {
          failAdd(s, desc ? 'Nie udało się dodać do koszyka: ' + desc : NET_ERROR);
        }
      });
      return;
    }
    if (status && status >= 400 && status < 500 && desc) {
      failAdd(s, 'Nie udało się dodać do koszyka: ' + desc);
      return;
    }
    // Sieć, 5xx, przekroczony czas
    failAdd(s, NET_ERROR);
  }

  function onAdded(s, fullCart, bundleKey, bundleUid, variantIds, mintPromise) {
    var t0 = Date.now();

    if (!s.finished && active === s) {
      s.state = 'added';
      var cta = q(s.popup, '[data-bundle-pop-add]');
      if (cta) {
        cta.removeAttribute('aria-busy');
        cta.classList.remove('is-busy');
      }
      // Czarne CTA, „Dodano” i rysowany znaczek (stroke-dashoffset, 300 ms) — CSS na data-state="added"
      paintPopup(s, s.last || computeState(s.popup, s.root), { animate: true });
      haptic([12, 40, 18]);
      announce(s, 'Dodano do koszyka.');
    }
    updateCartCount(fullCart);

    // Bramka zamknięcia: ≥ 650 ms (RM 300), czekamy na mint najwyżej 1,5 s
    var minHold = RM.matches ? 300 : 650;
    Promise.race([mintPromise, wait(1500)]).then(function () {
      setTimeout(closeAndOpenCart, Math.max(0, minHold - (Date.now() - t0)));
    });

    function closeAndOpenCart() {
      var wentBack = false;
      if (active === s && !s.closing) wentBack = closePopup(s.root, { reason: 'added' });
      // inert już zdjęty: fokus na przycisk karty, zanim otworzy się drawer — jego pułapka fokusu
      // zapamięta go jako cel powrotu (zamiast <body> po ukryciu popupu)
      if (s.trigger && document.body.contains(s.trigger)) focusEl(s.trigger);
      if (wentBack) setTimeout(openCart, 60);
      else openCart();
    }

    // Kolejność jak dotąd: refreshAndOpenCart → rememberBundleCode → applyDiscountNow → recalculateCartDiscounts
    function openCart() {
      var trigger = s.trigger;
      var drawer = document.getElementById('mini-cart');
      // Pułapka fokusu drawera włącza się 150 ms po otwarciu i zapamiętuje cel powrotu (przycisk karty);
      // gdy sama nie wciągnęła fokusu do drawera, robimy to po niej
      if (drawer) {
        var onOpen = function () {
          drawer.removeEventListener('openable-element:open', onOpen);
          setTimeout(function () { keepDrawerFocus(trigger, true); }, 400);
        };
        drawer.addEventListener('openable-element:open', onOpen);
        setTimeout(function () { drawer.removeEventListener('openable-element:open', onOpen); }, 5000);
      }
      refreshAndOpenCart(fullCart);
      // Drawer przerysowuje treść (odświeżenie, rabat) — fokus z usuniętego elementu spada na <body>
      setTimeout(function () { keepDrawerFocus(trigger, false); }, 2000);

      mintPromise.then(function (res) {
        if (res.code) {
          rememberBundleCode(bundleUid, res.code);
          return applyDiscountNow(res.code).then(recalcLater).then(function () {
            setTimeout(function () { keepDrawerFocus(trigger, false); }, 300);
          });
        }
        if (res.failed) {
          // Dodane bez rabatu — drawer może zaproponować ponowne naliczenie (BundlePromo.retryMint)
          window.__bundleMintFailed = window.__bundleMintFailed || {};
          window.__bundleMintFailed[bundleUid] = { bundleKey: bundleKey, variantIds: variantIds };
          document.dispatchEvent(new CustomEvent('bundle:discount-failed', { detail: { uid: bundleUid } }));
        }
        return null;
      }).catch(function (err) {
        console.warn('[bundle-upsell] discount apply failed', err);
      });
    }
  }

  // Otwarty drawer koszyka, a fokus zgubiony na <body> (albo, tuż po włączeniu pułapki drawera, nadal na
  // przycisku karty) → przycisk zamknięcia drawera. Fokus gdzie indziej (w drawerze, przeniesiony przez klienta)
  // zostaje bez zmian. fromTrigger tylko po włączeniu pułapki — wtedy cel powrotu jest już zapamiętany.
  function keepDrawerFocus(trigger, fromTrigger, tries) {
    var drawer = document.getElementById('mini-cart');
    if (!drawer || !drawer.hasAttribute('open')) return;
    var cur = document.activeElement;
    var lost = !cur || cur === document.body || cur === document.documentElement;
    if (!lost && !(fromTrigger && trigger && cur === trigger)) return;
    var btn = drawer.querySelector('[data-action="close"]');
    focusEl(btn);
    // Drawer jeszcze w przejściu (visibility) — przycisk nie przyjmuje fokusu; kilka ponownych prób
    if (btn && document.activeElement !== btn && (tries == null ? 4 : tries) > 0) {
      setTimeout(function () { keepDrawerFocus(trigger, fromTrigger, (tries == null ? 4 : tries) - 1); }, 250);
    }
  }

  function runBundleAdd(s) {
    if (!s || s.closing || s.finished || s.state === 'adding' || s.state === 'added') return;
    var popup = s.popup;
    var root = s.root;
    var items = popItems(popup);
    if (!items.main || !items.comp) return;

    // Walidacja: oba rozmiary
    var st = computeState(popup, root);
    if (st.unavailable) {
      // Wyprzedany produkt (żaden rozmiar) — CTA „Wyprzedane”, nic nie dodajemy
      announce(s, soldOutText(st) + '.');
      return;
    }
    var missing = [st.main, st.comp].filter(function (i) { return !i.resolved; }).map(function (i) { return i.item; });
    if (missing.length) {
      nudgeMissing(s, missing);
      return;
    }
    var mainId = itemVariantId(items.main);
    var compId = itemVariantId(items.comp);
    if (!mainId || !compId) {
      nudgeMissing(s, [!mainId ? items.main : items.comp]);
      return;
    }
    if (mainId === compId) {
      failAdd(s, 'Wybierz inny produkt do pary.');
      return;
    }

    var bundleKey = (root.getAttribute('data-bundle-code') || '').trim();
    var bundleUid = newBundleUid();
    var variantIds = [mainId, compId];
    var cta = q(popup, '[data-bundle-pop-add]');

    s.state = 'adding';
    hideFormError(popup);
    setFieldsetsDisabled(popup, true);
    // CTA zostaje fokusowalny (atrybut disabled zrzuciłby fokus na <body>): aria-disabled z paintPopup + aria-busy;
    // ponowne kliknięcia odcina stan „adding” w runBundleAdd
    if (cta) cta.setAttribute('aria-busy', 'true');
    paintPopup(s, st);
    // Wskaźnik „dodajemy” (przygasające kropki, bez obrotu) tylko, gdy dodawanie trwa dłużej niż 150 ms
    var spinTimer = setTimeout(function () {
      if (s.state === 'adding' && cta) cta.classList.add('is-busy');
    }, 150);
    setDrawerLock(true);

    // Jeden zestaw w koszyku (ONE_BUNDLE_MSG): linie zestawu z karty produktu i z kreatora mają _bundle.
    // Błąd cart.js nie blokuje dodania. Sprawdzenie przed mintem, żeby nie tworzyć zbędnego kodu.
    fetchCart().then(function (cart) {
      return (cart.items || []).some(function (line) { return line.properties && line.properties._bundle; });
    }, function () { return false; }).then(function (hasBundle) {
      if (s.finished || active !== s) return;
      if (hasBundle) {
        clearTimeout(spinTimer);
        setDrawerLock(false);
        failAdd(s, ONE_BUNDLE_MSG);
        return;
      }
      startAdd();
    });

    function startAdd() {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var abortTimer = null;
      var timeout = new Promise(function (resolve, reject) {
        abortTimer = setTimeout(function () {
          if (ctrl) ctrl.abort();
          var err = new Error('timeout');
          err.name = 'TimeoutError';
          reject(err);
        }, ADD_TIMEOUT);
      });

      // Mint równolegle z dodawaniem — koszyk otwiera się po add, rabat dogania
      var mintPromise = mintWithRetry(bundleKey, variantIds, st.deal);

      // Limit 12 s tylko na add.js. Po udanym add para jest już w koszyku: cart.js służy tylko licznikowi
      // i drawerowi — jego błąd albo opóźnienie (najwyżej 4 s) nie cofa sukcesu (drawer sam pobierze koszyk)
      Promise.race([
        addBundlePair(mainId, compId, bundleKey, bundleUid, ctrl ? ctrl.signal : undefined, st.deal ? st.B : 0),
        timeout
      ]).then(function () {
        clearTimeout(abortTimer);
        return Promise.race([
          fetchCart().then(null, function (err) {
            console.warn('[bundle-upsell] cart.js after add failed', err);
            return null;
          }),
          wait(4000).then(function () { return null; })
        ]);
      }).then(function (fullCart) {
        clearTimeout(spinTimer);
        onAdded(s, fullCart, bundleKey, bundleUid, variantIds, mintPromise);
      }, function (err) {
        clearTimeout(abortTimer);
        clearTimeout(spinTimer);
        console.error('[bundle-upsell]', err);
        setDrawerLock(false);
        onAddError(s, err);
      });
    }
  }

  // Ponowne naliczenie rabatu dla zestawu w koszyku (przycisk w drawerze, §6.5)
  window.BundlePromo = window.BundlePromo || {};
  window.BundlePromo.retryMint = function (uid) {
    if (!uid) return Promise.resolve(false);
    return fetchCart().then(function (cart) {
      var lines = (cart.items || []).filter(function (line) {
        return line.properties && line.properties._bundle_uid === uid;
      });
      if (!lines.length) return false;
      var failed = window.__bundleMintFailed && window.__bundleMintFailed[uid];
      var bundleKey = (failed && failed.bundleKey) || lines[0].properties._bundle;
      var ids = [];
      lines.forEach(function (line) {
        if (ids.indexOf(line.variant_id) === -1) ids.push(line.variant_id);
      });
      if (!bundleKey) return false;

      return mintBundleCode(bundleKey, ids).then(function (code) {
        if (!code) return false;
        rememberBundleCode(uid, code);
        return applyDiscountNow(code).then(function () {
          if (failed) delete window.__bundleMintFailed[uid];
          return recalcLater();
        }).then(function () { return true; });
      });
    }).catch(function (err) {
      console.warn('[bundle-upsell] retryMint failed', err);
      return false;
    });
  };

  /* ============ Wiązanie bloku ============ */

  function bindPopup(root, popup) {
    popup.addEventListener('click', function (event) {
      var s = active;
      if (!s || s.popup !== popup) return;
      var closeEl = event.target.closest('[data-bundle-pop-close]');
      if (closeEl) {
        event.preventDefault();
        // Drugi tap z podwójnego stuknięcia w kartę trafia w overlay — nie zamykaj od razu
        if (closeEl.classList.contains('bundle-pop__overlay') && Date.now() - s.openedAt < 350) return;
        closePopup(root, { reason: 'dismiss' });
        return;
      }
      var addBtn = event.target.closest('[data-bundle-pop-add]');
      if (addBtn) {
        event.preventDefault();
        // aria-disabled = walidacja (przycisk nadal klikalny); stany adding/added odcina runBundleAdd
        runBundleAdd(s);
      }
    });

    popup.addEventListener('change', onRadioChange);

    var dialog = popup.querySelector('.bundle-pop__dialog');
    if (dialog) dialog.addEventListener('keydown', trapTab);

    // Przewijanie treści (walidacja, auto-przewinięcie do kroku, niskie ekrany): linia pod górą okna
    var body = popup.querySelector('[data-pop-body]');
    if (dialog && body) {
      body.addEventListener('scroll', function () {
        dialog.classList.toggle('is-scrolled', body.scrollTop > 0);
      }, { passive: true });
    }
  }

  function warmPopupImages(popup) {
    if (!popup || popup.__warmed) return;
    popup.__warmed = true;
    $$('img[loading="lazy"]', popup).forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function bindRoot(root) {
    if (!root || root.getAttribute(BOUND) === 'true') return;
    root.setAttribute(BOUND, 'true');
    setupCarousel(root);
    setupPara(root);

    // position: fixed nie działa pod przodkiem z transform (sticky kolumna PDP) — popup do <body>
    var popup = root.querySelector('[data-bundle-pop]');
    if (popup) {
      root.__bundlePopup = popup;
      var forId = popup.getAttribute('data-bundle-pop-for') || '';
      if (forId) {
        // Po przeładowaniu sekcji w edytorze zostaje stary popup tego bloku
        $$('body > [data-bundle-pop-for]').forEach(function (old) {
          if (old === popup || old.getAttribute('data-bundle-pop-for') !== forId) return;
          if (active && active.popup === old) forceClose(active);
          old.parentNode.removeChild(old);
        });
      }
      document.body.appendChild(popup);
      bindPopup(root, popup);

      // Zdjęcia ukrytego popupu (kafel „Ten produkt”, awatar) są leniwe — nie konkurują z PDP przy ładowaniu;
      // rozgrzewka przy pierwszym kontakcie z blokiem, zanim klient kliknie kartę
      var warm = function () { warmPopupImages(popup); };
      root.addEventListener('pointerover', warm, { once: true, passive: true });
      root.addEventListener('touchstart', warm, { once: true, passive: true });
      root.addEventListener('focusin', warm, { once: true });
    }

    root.addEventListener('click', function (event) {
      // v5 „polecana” / „razem”: miniatura innej pary podmienia widoczną parę (bez otwierania popupu)
      var paraOpen = event.target.closest('[data-para-open]');
      if (paraOpen && root.contains(paraOpen)) {
        event.preventDefault();
        var selTile = paraSelected(root);
        if (selTile) openPopup(root, selTile, paraOpen);
        return;
      }
      var pick = event.target.closest('[data-pair-pick]');
      if (pick && root.contains(pick)) {
        event.preventDefault();
        if (pick.hasAttribute('data-para-tile')) selectParaTile(root, pick);
        else selectPair(root, pick.getAttribute('data-pair-pick'));
        return;
      }
      // Klik w dowolne miejsce karty otwiera popup
      var card = event.target.closest('[data-bundle-card]');
      if (card && root.contains(card)) {
        event.preventDefault();
        openPopup(root, card, card.querySelector('[data-bundle-open]'));
      }
    });
  }

  /* ============ Nasłuchy globalne ============ */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (active && !active.closing) closePopup(active.root, { reason: 'esc' });
  });

  // Obrót telefonu / zmiana okna przy otwartym popupie — tytuły kolumn mogą zmienić liczbę linii
  var titlesRaf = 0;
  window.addEventListener('resize', function () {
    if (!active || active.closing || titlesRaf) return;
    titlesRaf = requestAnimationFrame(function () {
      titlesRaf = 0;
      if (active && !active.closing) syncTitles(active.popup);
    });
  });

  // „Wstecz” zamyka otwarty popup (wpis dodany przy otwarciu); nasz własny history.back() pomijamy
  window.addEventListener('popstate', function (e) {
    if (backPendingUntil && Date.now() < backPendingUntil) {
      backPendingUntil = 0;
      return;
    }
    backPendingUntil = 0;
    var s = active;
    if (!s || s.closing || !s.pushed) return;
    // Pomijamy tylko powrót na wpis TEGO otwarcia (token). Wpis {bundlePop} z innej sesji — np. strona przeładowana
    // przy otwartym arkuszu — to zwykłe „Wstecz”, które ma zamknąć arkusz
    if (e.state && e.state.bundlePop && e.state.t === s.token) return;
    if (s.state === 'adding') {
      // Trwa dodawanie — popup zostaje otwarty; przywracamy wpis, żeby kolejne „Wstecz” nadal zamykało arkusz,
      // a nie opuszczało strony produktu (po błędzie popup zostaje z ochroną historii)
      try {
        history.pushState(historyEntry(s), '');
      } catch (err) {
        s.pushed = false;
      }
      return;
    }
    // „added”: wpis zużyty, popup zamknie bramka po dodaniu (bez dodatkowego history.back())
    s.pushed = false;
    closePopup(s.root, { reason: 'popstate' });
  });

  // Klient sam zmienił opcję na karcie produktu (motyw wysyła też syntetyczne change — te pomijamy)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!e.isTrusted || !t || !t.matches || !t.matches('[name^="option"]')) return;
    var pv = t.closest('product-variants');
    var form = getMainProductForm();
    // form.id to pole <input name="id">, nie identyfikator — porównujemy atrybut
    if (pv && form && pv.getAttribute('form-id') === form.getAttribute('id')) {
      mainUserPicked = true;
      // Nowszy wybór na stronie produktu wygrywa z rozmiarem zapamiętanym w oknie
      $$('[data-bundle-upsell]').forEach(function (r) { if (r.__paraPicks) delete r.__paraPicks.main; });
    }
  }, true);

  // Zmiana wariantu głównego produktu (motyw: „variant:changed” na formularzu) → nowe M:
  // zysk w podtytule, „+dopłata”, przekreślona cena i plakietki kart (te same wzory co Liquid, bez count-upu)
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || event.target !== getMainProductForm()) return;

    $$('[data-bundle-upsell]').forEach(function (root) {
      root.__mainVariant = variant;
      root.setAttribute('data-main-price', String(variant.price));
      syncBlock(root, true);
    });
  });

  // Zabezpieczenie: gdy strona (lub sekcja w edytorze / dev serverze) przeładuje się z otwartym popupem, na elementach
  // strony mógłby zostać inert i klasa na <html> — wtedy nic nie da się kliknąć. Bez aktywnej sesji sprzątamy ślady.
  function clearStaleLock() {
    if (active) return;
    $$('body > [inert]').forEach(function (el) { el.removeAttribute('inert'); });
    document.documentElement.classList.remove('bundle-pop-open');
    $$('body > [data-bundle-pop]:not([hidden])').forEach(function (p) {
      p.hidden = true;
      p.setAttribute('data-open', 'false');
    });
  }

  function init(scope) {
    clearStaleLock();
    $$('[data-bundle-upsell]', scope || document).forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Usunięcie sekcji w edytorze — popup przeniesiony do <body> trzeba sprzątnąć ręcznie
  document.addEventListener('shopify:section:unload', function (event) {
    $$('[data-bundle-upsell]', event.target).forEach(function (root) {
      var popup = root.__bundlePopup;
      if (active && active.root === root) forceClose(active);
      if (popup && popup.parentNode) popup.parentNode.removeChild(popup);
    });
  });
})();
